import React, { useState, useEffect, useRef } from "react";
import { Toaster, toast } from "react-hot-toast";
import { showToast } from "../../Helpers/showToast";
import { useLocation, useNavigate } from "react-router-dom";
import { API_URL, API_URL_SA } from "../../env";
import { GET, POST } from "../../Services/AxiosService";
import { CustomStringify } from "../../Helpers/CustomStringify";
import { DateToShow } from "../../Helpers/DateToShow";
import { DateToShowSplit } from "../../Helpers/DateToShowSplit";
import TypeCase from "../../Helpers/TypeCase";
import { useSelector, useDispatch } from "react-redux";
import { fetchListAC } from "../../Redux/CommonListData/AccountNameListSlice";
import { fetchListAgent } from "../../Redux/CommonListData/AgentNameListSlice";
import { fetchListTMBR } from "../../Redux/CommonListData/TeamMemberNameListSlice";
import { fetchListTrans } from "../../Redux/CommonListData/TransportNameListSlice";
import { fetchListSUPFG } from "../../Redux/CommonListData/SupplyDesignNameListSlice";

import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { DialogActions, IconButton, Stack } from "@mui/material";
import AddCircleOutlinedIcon from "@mui/icons-material/AddCircleOutlined";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import DeleteIcon from "@mui/icons-material/Delete";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Tooltip from "@mui/material/Tooltip";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import TotalDetail from "../../Components/TotalDetail/TotalDetail";
import AddColorSizeDialog from "../../Components/Dialog/AddColorSizeDialog";
import AddFGDesign from "../Masters/AddFGDesign";
import DeleteDialog from "../../Components/Dialog/DeleteDialog";
import PasswordDialog from "../../Components/Dialog/PasswordDialog";
import { fetchPOpendingList } from "../../Redux/TransactionsData/PackingChallanDataSlice";
export default function AddPackingChallan() {
  const [shouldReRender, setShouldReRender] = useState(false);
  const [shouldReRenderRaw, setShouldReRenderRaw] = useState(false);

  const { cmpdetail } = useSelector((state) => state.CompanyDetail);
  const UserDetail = useSelector((state) => state.UserDetail);
  const Theme = useSelector((state) => state.Theme);
  const AccountNameList = useSelector((state) => state.AccountNameList?.result);
  const TransportNameList = useSelector(
    (state) => state.TransportNameList?.result,
  );
  const SundryNameList = useSelector((state) => state.SundryNameList?.result);
  const ProductNameList = useSelector((state) => state.ProductNameList?.result);
  const SupplyDesignNameList = useSelector(
    (state) => state.SupplyDesignNameList?.result,
  );

  console.log({ SupplyDesignNameList })
  const PopendingList = useSelector(
    (state) => state.PackingChallanData?.poresult?.data,
  );

  const ColorNameList = useSelector((state) => state.ColorNameList?.result);
  const SizeNameList = useSelector((state) => state.SizeNameList?.result);
  const BarcodeNameList = useSelector((state) => state.BarcodeNameList?.result);
  const UnitNameList = useSelector((state) => state.UnitNameList?.result);

  const BarcodeAll = useSelector((state) => state.BarcodeAll?.result);
  const DesignAll = useSelector((state) => state.DesignAll?.result);
  const ProductAll = useSelector((state) => state.ProductAll?.result);
  const ColorAll = useSelector((state) => state.ColorAll?.result);
  const SizeAll = useSelector((state) => state.SizeAll?.result);
  const LocationAll = useSelector((state) => state.LocationAll?.result);

  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const filter = createFilterOptions();

  const [rowId, setRowId] = useState(1);
  const [itemIndex, setItemIndex] = useState();
  const [sunIndex, setSunIndex] = useState();
  const itemButton = document.getElementById("itemButton");

  const [Led_ID, setLed_ID] = useState();
  const [BillNo, setBillNo] = useState();
  const [BillDate, setBillDate] = useState();
  const [Trp_ID, setTrp_ID] = useState();

  const [isEditItemForm, setIsEditItemForm] = useState(false);

  const [itemDataArray, setitemDataArray] = useState([]);

  const [formDataItem, setformDataItem] = useState({
    supplier_id: UserDetail?.result?.user?.id,
    supplier_name: UserDetail?.result?.user?.company_name,
    del_days: "",
    design_id: "",
    supply_design: "",
    design_no: "",
    design_desc: "",
    product: "",
    hsn_code: "",
    qty: 0,
    mtrs: "",
    rate: "",
    cgst: 0,
    sgst: 0,
    igst: 0,
    et_id: 0,
    gstper: 0,
    gsttype: [],
    totalgst: 0,
    remark: "",
    colors: [
      {
        qty: 0,
        et_color_id: 0,
        colorId: 0,
        color_name: "Mix",
        sizes: [
          {
            qty: 0,
            et_size_id: 0,
            sizeId: 1,
            size_name: "No Size",
          },
        ],
      },
    ],
    images: [],
  });

  const [SuppDsgnNmCD, setSuppDsgnNmCD] = useState();
  const [POpendingID, setPOpendingID] = useState();
  const [PodIdNme, setPodIdNme] = useState();
  const [ProductHSN, setProductHSN] = useState();
  const [TotalQuantity, setTotalQuantity] = useState();
  const [DsgRate, setDsgRate] = useState();
  const [isDisAmt, setIsDisAmt] = useState(false);
  const [DiscountPer, setDiscountPer] = useState(
    UserDetail?.result?.user?.discount_per || 0,
  );
  const [DiscountAmt, setDiscountAmt] = useState();
  const [AmountBFT, setAmountBFT] = useState();
  const [cgstValue, setcgstValue] = useState();
  const [sgstValue, setsgstValue] = useState();
  const [igstValue, setigstValue] = useState();
  const [itemTotalAmt, setitemTotalAmt] = useState();

  const [passunitkey, setpassunitkey] = useState(0);
  const [QtyInputfocus, setQtyInputfocus] = useState(false);
  const [setQtyCheck, setSetQtyCheck] = useState(false);
  const [GstRates, setGstRates] = useState({});
  const [TaxRanges, setTaxRanges] = useState({});
  const [newArray, setNewArray] = useState([]);

  const [dsgwiseData, setDsgwiseData] = useState([]);
  const [UniqueSizes, setUniqueSizes] = useState([]);
  const [RawClrSize, setRawClrSize] = useState([]);

  const [mainTotalQty, setMainTotalQty] = useState();
  const [mainTotalDiscount, setMainTotalDiscount] = useState();
  const [mainTotalTaxableAmt, setMainTotalTaxableAmt] = useState();
  const [mainTotalItemCgst, setMainTotalItemCgst] = useState();
  const [mainTotalItemSgst, setMainTotalItemSgst] = useState();
  const [mainTotalItemIgst, setMainTotalItemIgst] = useState();
  const [mainTotalAmount, setMainTotalAmount] = useState();

  const [DesignName, setDesignName] = useState();

  const [Loader, setLoader] = useState(false);
  const [IsClrSize, setIsClrSize] = useState(false);

  const handleSwitchClrSize = async (event) => {
    const { checked } = event.target;
    setIsClrSize(checked);

    setShouldReRenderRaw(true);
    setTimeout(() => setShouldReRenderRaw(false), 1);
  };

  const [ItemRadio, setItemRadio] = useState("2");

  const handleItemRadio = (event) => {
    setItemRadio(event.target.value);
    emptyFormData();
  };

  const [tabValue, setTabValue] = useState("1");

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const [modalOpenAddNew, setModalOpenAddNew] = useState(false);
  const [modalOpenAddClrSize, setModalOpenAddClrSize] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalOpenDelete, setModalOpenDelete] = useState(false);
  const [modalOpenPassword, setModalOpenPassword] = useState(false);

  const [modalOpenSecond, setModalOpenSecond] = useState(false);
  const [allChecked, setAllChecked] = useState(false);
  const [checkedList, setCheckedList] = useState([]);
  const [modalOpenThird, setModalOpenThird] = useState(false);
  const [editShowIndex, setEditShowIndex] = useState(false);
  const [viewSetClrSize, setViewSetClrSize] = useState([]);
  const [viewRawClrSize, setViewRawClrSize] = useState([]);
  const [viewSetQty, setViewSetQty] = useState([]);
  const [viewUnitId, setViewUnitId] = useState([]);

  const handleModalOpenAddNew = () => {
    setModalOpenAddNew(true);
  };

  const handleModalCloseSecond = () => {
    setModalOpenSecond(false);
    setPOpendingID();
    setAllChecked(false);
    setCheckedList([]);
  };

  // const editViewClrSize = async (desgId, unitId, setId, setQty, ClrSize) => {
  //   setViewUnitId(unitId);
  //   if (setId > 0) {
  //     setViewSetClrSize(ClrSize);
  //     setViewSetQty(setQty);
  //   } else if (ClrSize?.length > 0 && !(setId > 0)) {
  //     // var rawClrSize = await getClrSizeData(desgId);
  //     var rawClrSize = [];

  //     const updatedRawClrSize = rawClrSize?.map((item1) => {
  //       const matchingColor = ClrSize?.find(
  //         (item2) => item2.colorId == item1.colorId,
  //       );
  //       if (matchingColor) {
  //         const updatedSizes = item1.sizes?.map((item3) => {
  //           const matchingSize = matchingColor.sizes?.find(
  //             (item4) => item4.sizeId === item3.sizeId,
  //           );
  //           if (matchingSize) {
  //             return {
  //               ...item3,
  //               perSizeQty: matchingSize.perSizeQty,
  //             };
  //           } else {
  //             return item3;
  //           }
  //         });

  //         return { ...item1, sizes: updatedSizes };
  //       } else {
  //         return item1;
  //       }
  //     });
  //     setViewRawClrSize(updatedRawClrSize);
  //   }
  // };

  // const handleModalOpenThird = async (item, index) => {
  //   console.log(item,"unitunitunitunitunit")
  //   await editViewClrSize(
  //     item?.design_id,
  //     item?.unit,
  //     item?.PUC_Detail_SetId,
  //     item?.PUC_Detail_SetQty,
  //     item?.colors || [],
  //   );
  //   setModalOpenThird(true);
  //   setEditShowIndex(index);
  // };

  const handleFinalSave = () => {
    setshowItemDataArray((prevList) => {
      const updatedList = [...prevList];
      const targetIndex = editShowIndex;

      // Update the specific item's colors
      updatedList[targetIndex] = {
        ...updatedList[targetIndex],
        colors: viewRawClrSize,
        // Recalculate total item qty
        qty: viewRawClrSize.reduce((acc, curr) => acc + curr.qty, 0),
      };

      return updatedList;
    });

    setModalOpenThird(false); // Close the modal
  };

  // const handleEditShow = (type, value, rowIndex, sizeId) => {
  //   if (type === "showClrSize") {
  //     setViewRawClrSize((prev) => {
  //       // 1. Deep clone the array to avoid direct mutation
  //       const updatedColors = JSON.parse(JSON.stringify(prev));

  //       // 2. Target the specific row by index
  //       const colorObj = updatedColors[rowIndex];

  //       if (colorObj) {
  //         // 3. Find the size object within that specific row
  //         const sizeObj = colorObj.sizes.find((s) => s.sizeId === sizeId);
  //         if (sizeObj) {
  //           // Update both to be safe, though consistency is better
  //           sizeObj.perSizeQty = value;
  //           sizeObj.size_qty = value;
  //         }

  //         // 4. Recalculate total qty for this specific row
  //         colorObj.qty = colorObj.sizes.reduce(
  //           (sum, s) => sum + (Number(s.size_qty) || 0),
  //           0
  //         );
  //       }
  //       return updatedColors;
  //     });
  //   }
  // };
  const handleEditShow = (type, value, rowIndex, sizeId) => {
    if (type === "showClrSize") {
      setViewRawClrSize((prev) => {
        const updatedColors = JSON.parse(JSON.stringify(prev));

        const colorObj = updatedColors[rowIndex];

        if (colorObj) {
          const sizeObj = colorObj.sizes.find(
            (s) => s.sizeId === sizeId
          );

          if (sizeObj) {
            // ✅ store edited value separately
            sizeObj.qty = value;
          }

          // ✅ calculate total using qty OR fallback bal_qty
          colorObj.qty = colorObj.sizes.reduce((sum, s) => {
            return (
              sum +
              Number(s.qty ?? s.bal_qty ?? 0)
            );
          }, 0);
        }

        return updatedColors;
      });
    }

    if (type === "showRate") {
      setshowItemDataArray((prev) =>
        prev.map((item, index) => {
          if (index !== rowIndex) return item;

          return {
            ...item,
            rate: value,
          };
        })
      );
    }
  };
  const handleModalOpenThird = async (item, index) => {
    setEditShowIndex(index); // CRITICAL: Store which row we are editing
    setViewUnitId(item?.unit);

    // Create a deep copy of the colors to edit in the modal
    const colorsCopy = JSON.parse(JSON.stringify(item?.colors || []));
    setViewRawClrSize(colorsCopy);

    setModalOpenThird(true);
  };
  const handleModalCloseThird = () => {
    setModalOpenThird(false);
    setViewSetClrSize([]);
    setViewRawClrSize([]);
    setViewSetQty();
    setViewUnitId();
  };
  const handleallCheckbox = (checked) => {
    setAllChecked(checked);
    const newCheckedList = showItemDataArray?.map((item) => {
      return checked;
    });
    setCheckedList(newCheckedList);
    setShouldReRender(true);
    setTimeout(() => setShouldReRender(false), 1);
  };

  const handleModalCloseAddNew = async (event, Id) => {
    setModalOpenAddNew(false);

    if (DesignName && Id?.value) {
      dispatch(fetchListSUPFG({ cmpdetail, UserDetail }));

      emptyFormData();
      setSuppDsgnNmCD(Id);
      await GetSupDesignDetails(Id?.value);
      setformDataItem((prevData) => ({
        ...prevData,
        design_id: Id?.value,
        supply_design: Id?.label,
        design_no: Id?.design_no,
      }));
    }

    setDesignName();

    setShouldReRender(true);
    setTimeout(() => setShouldReRender(false), 1);
  };

  const handleCheckboxChange = (checked, index) => {
    const newCheckedList = [...checkedList];
    newCheckedList[index] = checked;
    setCheckedList(newCheckedList);

    if (newCheckedList?.length == showItemDataArray?.length) {
      if (
        newCheckedList?.includes(false) ||
        newCheckedList?.includes(undefined)
      ) {
        setAllChecked(false);
      } else {
        setAllChecked(true);
      }
    } else {
      setAllChecked(false);
    }

    setShouldReRender(true);
    setTimeout(() => setShouldReRender(false), 1);
  };

  // const AddShowItemDataArray = () => {
  //   if (!checkedList?.includes(true)) {
  //     showToast("No Items Selected", "error");
  //     return;
  //   }

  //   const selectedShowArrays = showItemDataArray?.filter(
  //     (_, index) => checkedList[index],
  //   );

  //   const mergeColors = (oldColors = [], newColors = []) => {
  //     const merged = [...oldColors];

  //     newColors.forEach((newColor) => {
  //       const colorIndex = merged.findIndex(
  //         (c) => c.colorId === newColor.colorId,
  //       );

  //       if (colorIndex !== -1) {
  //         // Merge sizes
  //         const existingSizes = merged[colorIndex].sizes || [];

  //         newColor.sizes.forEach((newSize) => {
  //           const sizeIndex = existingSizes.findIndex(
  //             (s) =>
  //               s.sizeId === newSize.sizeId &&
  //               s.BarcodeNo === newSize.BarcodeNo,
  //           );

  //           if (sizeIndex !== -1) {
  //             existingSizes[sizeIndex].size_qty =
  //               Number(existingSizes[sizeIndex].size_qty || 0) +
  //               Number(newSize.size_qty || 0);
  //           } else {
  //             existingSizes.push({ ...newSize });
  //           }
  //         });

  //         merged[colorIndex].sizes = existingSizes;
  //       } else {
  //         merged.push({ ...newColor });
  //       }
  //     });

  //     return merged;
  //   };

  //   let rowItems = 0;

  //   selectedShowArrays.forEach((sItem, index) => {
  //     const updatedItem = {
  //       ...sItem,
  //       PUC_Detail_Flag_ID: rowId + index,
  //     };

  //     const sameItemIndex = itemDataArray?.findIndex((item) => {
  //       return (
  //         Number(item?.design_id) === Number(updatedItem?.design_id) &&
  //         Number(item?.productId) === Number(updatedItem?.productId) &&
  //         Number(item?.rate) === Number(updatedItem?.rate) &&
  //         item?.unit === updatedItem?.unit

  //       );
  //     });

  //     if (sameItemIndex !== -1) {
  //       setitemDataArray((prevArray) =>
  //         prevArray.map((item, i) => {
  //           if (i !== sameItemIndex) return item;

  //           return {
  //             ...item,

  //             qty: Number(item.qty || 0) + Number(updatedItem.qty || 0),
  //             colors: mergeColors(item.colors, updatedItem.colors),
  //           };
  //         }),
  //       );
  //     } else {
  //       rowItems += 1;

  //       setitemDataArray((prevArray) => [...prevArray, updatedItem]);
  //       setRowId((prev) => prev + 1);
  //     }
  //   });
  //   handleModalCloseSecond();
  //   emptyFormData();
  // };

  const AddShowItemDataArray = () => {
    if (!checkedList?.includes(true)) {
      showToast("No Items Selected", "error");
      return;
    }

    const selectedShowArrays = showItemDataArray?.filter(
      (_, index) => checkedList[index]
    );

    //  GST + Amount Calculator (PURE FUNCTION)
    const calculateAmounts = (Qty, Rate, Discount, isDisAmt, gstRates) => {
      let totalQty = Qty || 0;
      let amountBf = totalQty * (Rate || 0);

      let disAmt = 0;
      if (isDisAmt) {
        disAmt = Discount || 0;
      } else {
        disAmt = amountBf * (Discount ? Discount / 100 : 0);
      }

      amountBf = amountBf - disAmt;

      const cgstVal = amountBf * ((gstRates?.cgst || 0) / 100);
      const sgstVal = amountBf * ((gstRates?.sgst || 0) / 100);
      const igstVal = amountBf * ((gstRates?.igst || 0) / 100);

      const total =
        Number(amountBf) +
        Number(cgstVal) +
        Number(sgstVal) +
        Number(igstVal);

      return {
        amountBf: amountBf.toFixed(2),
        discountAmt: disAmt.toFixed(2),
        cgstAmt: cgstVal.toFixed(2),
        sgstAmt: sgstVal.toFixed(2),
        igstAmt: igstVal.toFixed(2),
        total: total.toFixed(2),
      };
    };


    // Merge Colors
    const mergeColors = (oldColors = [], newColors = []) => {
      const merged = [...oldColors];

      newColors.forEach((newColor) => {
        const colorIndex = merged.findIndex(
          (c) => c.color_name === newColor.color_name
        );
        if (colorIndex !== -1) {
          const existingSizes = merged[colorIndex].sizes || [];

          newColor.sizes.forEach((newSize) => {
            const sizeIndex = existingSizes.findIndex(
              (s) =>
                s.sizeId === newSize.sizeId
            );
            if (sizeIndex !== -1) {
              existingSizes[sizeIndex].qty =
                Number(existingSizes[sizeIndex].qty || 0) +
                Number(newSize.qty || 0);
            } else {
              existingSizes.push({ ...newSize });
            }
          });

          merged[colorIndex].sizes = existingSizes;
        } else {
          merged.push({ ...newColor });
        }
      });

      return merged;
    };

    let updatedArray = [...itemDataArray];
    let newRowId = rowId;

    selectedShowArrays.forEach((sItem, index) => {
      //  GST TYPE HANDLING
      const gstType = sItem?.gsttype || [];

      let gstRates = {
        cgst: 0,
        sgst: 0,
        igst: 0,
      };

      if (gstType.includes("igst")) {
        gstRates.igst = sItem?.igst || 0;
      } else {
        gstRates.cgst = sItem?.cgst || 0;
        gstRates.sgst = sItem?.sgst || 0;
      }

      //  CALCULATE AMOUNTS
      const amounts = calculateAmounts(
        sItem?.qty,
        sItem?.rate,
        sItem?.discount_per || 0,
        false,
        gstRates
      );

      // FINAL OBJECT
      const updatedItem = {
        ...sItem,
        gsttype: gstType,

        cgst: gstRates.cgst,
        sgst: gstRates.sgst,
        igst: gstRates.igst,

        discount_per: sItem?.discount_per || 0,
        discount_amount: amounts.discountAmt,

        amountbft: amounts.amountBf,

        cgstamt: amounts.cgstAmt,
        sgstamt: amounts.sgstAmt,
        igstamt: amounts.igstAmt,

        amount: amounts.total,
      };

      console.log(updatedItem, "updatedItem")
      //  CHECK EXISTING ITEM
      const sameItemIndex = updatedArray.findIndex((item) => {
        return (
          Number(item?.id) === Number(updatedItem?.id) &&
          Number(item?.orderId) === Number(updatedItem?.orderId) &&
          item?.orderdate === updatedItem?.orderdate &&
          Number(item?.rate) === Number(updatedItem?.rate)
        );
      });

      const normalizeColors = (colors = []) =>
        colors.map((color) => {
          const sizes = (color.sizes || []).map((s) => ({
            ...s,
            qty: Number(s.qty || s.bal_qty || 0),
          }));

          return {
            ...color,
            sizes,

            // 🔥 THIS IS THE FIX
            qty: sizes.reduce((sum, s) => sum + s.qty || s.bal_qty || 0, 0),
          };
        });
      const calculateQtyFromColors = (colors = []) => {
        return colors.reduce((total, color) => {
          const colorQty = (color.sizes || []).reduce((sum, size) => {
            return sum + Number(size.qty || size.bal_qty || 0);
          }, 0);

          let sumTotal = total + colorQty;
          return sumTotal;
        }, 0);
      };
      if (sameItemIndex !== -1) {
        const existingItem = updatedArray[sameItemIndex];

        const mergedColors = mergeColors(
          existingItem.colors,
          updatedItem.colors,
        );
        const normalizedColors = normalizeColors(mergedColors);


        updatedArray[sameItemIndex] = {
          ...existingItem,
          colors: normalizedColors,
          qty: calculateQtyFromColors(mergedColors),
        };
      } else {
        // 🔥 normalize colors BEFORE push (same as merge)
        const normalizedColors = normalizeColors(updatedItem.colors);

        const finalItem = {
          ...updatedItem,
          colors: normalizedColors,

          // 🔥 root qty from colors
          qty: calculateQtyFromColors(normalizedColors),
        };

        updatedArray.push(finalItem);
        newRowId += 1;
      }
    });

    console.log(updatedArray, "updatedArray")
    //  UPDATE STATE ONCE
    setitemDataArray(updatedArray);
    setRowId(newRowId);

    handleModalCloseSecond();
    emptyFormData();
  };
  console.log(itemDataArray, "itemDataArray")

  const ToFixed = (value) => {
    return Number.isFinite(value) && !Number.isInteger(value)
      ? value.toFixed(2)
      : value;
  };

  let [PODtlIdArray, setPODtlIdArray] = useState([]);

  // const handleEditShow = async (
  //   DtlIdArry,
  //   name,
  //   value,
  //   ind,
  //   colorId,
  //   sizeId,
  // ) => {
  //   let newShow = [...showItemDataArray];
  //   let newQty = 0;
  //   let newDisAmt = 0;
  //   let newAmountBft = 0;
  //   let newCgstAmt = 0;
  //   let newSgstAmt = 0;
  //   let newIgstAmt = 0;
  //   let newAmount = 0;

  //   let clrArr = [];
  //   let clrArrInd = "";
  //   let clrSizesArr = [];
  //   let clrSizesArrInd = "";

  //   const indexToEdit = newShow?.findIndex((item, index) => index === ind);

  //   if (indexToEdit !== -1) {
  //     const newObj = { ...newShow[indexToEdit] };

  //     // let AvailableQty =
  //     //   PurchaseOrdList?.find(
  //     //     (i) =>
  //     //       i?.Dtl_ID ==
  //     //       DtlIdArry?.find(
  //     //         (e) =>
  //     //           e?.PUC_Detail_Colour == (colorId || 0) &&
  //     //           e?.PUC_Detail_Size == (sizeId || 0),
  //     //       )?.PUC_Detail_PODtlID,
  //     //   )?.PerSizeQty -
  //     //   ManipulateData(itemDataArray)
  //     //     ?.filter(
  //     //       (i) =>
  //     //         i?.PUC_Detail_PODtlID ==
  //     //         DtlIdArry?.find(
  //     //           (e) =>
  //     //             e?.PUC_Detail_Colour == (colorId || 0) &&
  //     //             e?.PUC_Detail_Size == (sizeId || 0),
  //     //         )?.PUC_Detail_PODtlID,
  //     //     )
  //     //     ?.reduce(
  //     //       (acc, itemData) =>
  //     //         acc +
  //     //         (itemData?.PUC_Detail_PerSizeQty || itemData?.PUC_Detail_Qty),
  //     //       0,
  //     //     );

  //     // let AvailableSetQty =
  //     //   PurchaseOrdList?.find(
  //     //     (i) =>
  //     //       i?.Dtl_ID ==
  //     //       DtlIdArry?.find((e) => e?.PUC_Detail_Colour == (colorId || 0))
  //     //         ?.PUC_Detail_PODtlID,
  //     //   )?.SetQty -
  //     //   ManipulateData(itemDataArray)
  //     //     ?.filter(
  //     //       (i) =>
  //     //         i?.PUC_Detail_PODtlID ==
  //     //         DtlIdArry?.find((e) => e?.PUC_Detail_Colour == (colorId || 0))
  //     //           ?.PUC_Detail_PODtlID,
  //     //     )
  //     //     ?.reduce((acc, itemData) => acc + itemData?.PUC_Detail_SetQty, 0);

  //     //----------------------------------------------
  //     let AvailableQty = 0;
  //     let AvailableSetQty = 0;
  //     if (name == "showRate") {
  //       newObj.PUC_Detail_Rate = value;
  //       newDisAmt =
  //         (newObj.PUC_Detail_DisPer / 100) * (newObj.PUC_Detail_Qty * value);
  //       newObj.PUC_Detail_DisAmt = ToFixed(newDisAmt);
  //       newAmountBft = newObj.PUC_Detail_Qty * value - Number(newDisAmt);
  //       newObj.PUC_Detail_AmountBFT = ToFixed(newAmountBft);
  //     } else if (name == "showQty") {
  //       if (!AvailableQty || value > (AvailableQty || 0)) {
  //         return;
  //       }

  //       newObj.PUC_Detail_Qty = value;
  //       newDisAmt =
  //         (newObj.PUC_Detail_DisPer / 100) * (value * newObj.PUC_Detail_Rate);
  //       newObj.PUC_Detail_DisAmt = ToFixed(newDisAmt);
  //       newAmountBft = value * newObj.PUC_Detail_Rate - Number(newDisAmt);
  //       newObj.PUC_Detail_AmountBFT = ToFixed(newAmountBft);
  //     } else if (name == "showSetQty") {
  //       if (!AvailableSetQty || value > (AvailableSetQty || 0)) {
  //         return;
  //       }

  //       // setViewSetQty(value);
  //       newObj.PUC_Detail_SetQty = value;
  //       newQty = value * newObj.PUC_Detail_PerSetQty;
  //       newObj.PUC_Detail_Qty = newQty;
  //       newDisAmt =
  //         (newObj.PUC_Detail_DisPer / 100) * (newQty * newObj.PUC_Detail_Rate);
  //       newObj.PUC_Detail_DisAmt = ToFixed(newDisAmt);
  //       newAmountBft = newQty * newObj.PUC_Detail_Rate - Number(newDisAmt);
  //       newObj.PUC_Detail_AmountBFT = ToFixed(newAmountBft);
  //     } else if (name == "showClrSize") {
  //       if (!AvailableQty || value > (AvailableQty || 0)) {
  //         return;
  //       }

  //       // setViewRawClrSize((pre) => {
  //       //   return pre?.map((elem) => {
  //       //     if (elem?.colorId == colorId) {
  //       //       return {
  //       //         ...elem,
  //       //         sizes: elem?.sizes?.map((ele) => {
  //       //           if (ele?.sizeId == sizeId) {
  //       //             return {
  //       //               ...ele,
  //       //               perSizeQty: Number(value),
  //       //             };
  //       //           } else {
  //       //             return ele;
  //       //           }
  //       //         }),
  //       //       };
  //       //     } else {
  //       //       return elem;
  //       //     }
  //       //   });
  //       // });

  //       clrArr = newObj.ClrSize;
  //       clrArr?.map((elem, i) => {
  //         if (elem?.colorId == colorId) {
  //           clrSizesArr = elem?.sizes;
  //           clrArrInd = i;
  //         }
  //       });

  //       clrSizesArr?.map((ele, i) => {
  //         if (ele?.sizeId === sizeId) {
  //           clrSizesArrInd = i;
  //         }
  //       });

  //       clrSizesArr.splice(clrSizesArrInd, 1, {
  //         sizeId: sizeId,
  //         perSizeQty: value,
  //       });
  //       clrArr.splice(clrArrInd, 1, {
  //         colorId: colorId,
  //         sizes: clrSizesArr,
  //       });
  //       newObj.ClrSize = clrArr;

  //       clrArr?.map((elem) => {
  //         elem?.sizes?.map((ele) => {
  //           newQty = newQty + ele?.perSizeQty;
  //         });
  //       });

  //       newObj.PUC_Detail_Qty = newQty;
  //       newDisAmt =
  //         (newObj.PUC_Detail_DisPer / 100) * (newQty * newObj.PUC_Detail_Rate);
  //       newObj.PUC_Detail_DisAmt = ToFixed(newDisAmt);
  //       newAmountBft = newQty * newObj.PUC_Detail_Rate - Number(newDisAmt);
  //       newObj.PUC_Detail_AmountBFT = ToFixed(newAmountBft);
  //     }

  //     newShow[indexToEdit] = newObj;

  //     setshowItemDataArray(newShow);
  //     // ----------------------------------------------

  //     var requestData = CustomStringify({
  //       Party_ID: Led_ID?.value,
  //       Party_StateID: Led_StateID,
  //       new_rate: name == "showRate" ? value : newObj.PUC_Detail_Rate,
  //       server: {
  //         Database: cmpdetail?.Database,
  //         Password: cmpdetail?.Password,
  //         Server: cmpdetail?.Server,
  //         User_ID: cmpdetail?.User_ID,
  //         Port: cmpdetail?.Port,
  //       },
  //     });

  //     try {
  //       const result = await POST(
  //         `/Get_ProductNamesByDesign_And_NewRateTax?Prod_id=${newObj.PUC_Detail_ProdID}`,
  //         requestData,
  //       );

  //       if (result?.status === true) {
  //         newObj.PUC_Detail_CGSTName = result?.data?.[0]?.cgstName;
  //         newObj.PUC_Detail_SGSTName = result?.data?.[0]?.sgstName;
  //         newObj.PUC_Detail_IGSTName = result?.data?.[0]?.igstName;

  //         newCgstAmt = (result?.data?.[0]?.cgstAmount / 100) * newAmountBft;
  //         newSgstAmt = (result?.data?.[0]?.sgstAmount / 100) * newAmountBft;
  //         newIgstAmt = (result?.data?.[0]?.igstAmount / 100) * newAmountBft;

  //         newObj.PUC_Detail_CGSTAmt = ToFixed(newCgstAmt);
  //         newObj.PUC_Detail_SGSTAmt = ToFixed(newSgstAmt);
  //         newObj.PUC_Detail_IGSTAmt = ToFixed(newIgstAmt);

  //         newAmount = newAmountBft + newCgstAmt + newSgstAmt + newIgstAmt;
  //         newObj.PUC_Detail_TotAmount = ToFixed(newAmount);
  //       } else {
  //         newObj.PUC_Detail_CGSTName = "";
  //         newObj.PUC_Detail_SGSTName = "";
  //         newObj.PUC_Detail_IGSTName = "";
  //         newObj.PUC_Detail_CGSTAmt = 0;
  //         newObj.PUC_Detail_SGSTAmt = 0;
  //         newObj.PUC_Detail_IGSTAmt = 0;
  //         newAmount = newAmountBft + newCgstAmt + newSgstAmt + newIgstAmt;
  //         newObj.PUC_Detail_TotAmount = ToFixed(newAmount);
  //       }
  //     } catch (error) {
  //       showToast(error?.response?.data?.message || error?.message, "error");
  //     } finally {
  //     }
  //     // -----------------------------------------------------

  //     newShow[indexToEdit] = newObj;

  //     setshowItemDataArray(newShow);
  //   }
  // };
  const handleModalOpenAddClrSize = () => {
    setModalOpenAddClrSize(true);
  };

  const handleModalCloseAddClrSize = (event, Id) => {
    setModalOpenAddClrSize(false);
  };

  const handleModalOpen = () => {
    if (Led_ID) {
      setModalOpen(true);
      setIsEditItemForm(false);
      emptyFormData();
    } else {
      showToast("Please Select Account", "error");
    }
  };

  const handleModalEdit = (item, index) => {
    if (!item.orderId) {
      setItemRadio(2);
    } else {
      setItemRadio(1);
    }
    editFormData(item, true);
    setModalOpen(true);
    setItemIndex(index);
  };

  const handleModalClose = () => {
    setModalOpen(false);
    setItemIndex();
  };

  const handleModalOpenDelete = (index, tab) => {
    setModalOpenDelete(true);
    if (tab == 1) {
      setItemIndex(index);
    } else {
      setSunIndex(index);
    }
  };

  const handleModalCloseDelete = () => {
    setModalOpenDelete(false);
    setItemIndex();
    setSunIndex();
  };

  const handleModalOpenPassword = () => {
    setModalOpenPassword(true);
  };

  const handleModalClosePassword = () => {
    setModalOpenPassword(false);
  };

  const hexToRGBFade = (hex, fade) => {
    hex = hex.replace("#", "");
    // Parse the red, green, and blue components from the hex string
    let r = parseInt(hex.substring(0, 2), 16);
    let g = parseInt(hex.substring(2, 4), 16);
    let b = parseInt(hex.substring(4, 6), 16);
    // Return the RGB value
    return `rgb(${r}, ${g}, ${b}, ${fade})`;
  };

  const sortByLabel = (obj1, obj2) => {
    let label1 = obj1.label?.toLowerCase();
    let label2 = obj2.label?.toLowerCase();

    if (label1 < label2) {
      return -1;
    }
    if (label1 > label2) {
      return 1;
    }
    return 0;
  };

  function sortByLabelNumber(obj1, obj2) {
    return Number(obj1.label) - Number(obj2.label);
  }

  const [ListOpen, setListOpen] = useState(false);
  const [ListLoading, setListLoading] = useState(false);

  const [dsgnList, setdsgnList] = useState([]);
  const [SupplydsgnList, setSupplydsgnList] = useState([]);

  const [POpendingListOption, setPOpendingListOption] = useState([]);

  const [prodList, setprodList] = useState([]);

  const handleListOpen = async (event) => {
    setListOpen(true);
    setListLoading(true);

    const myPromise = new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(true);
      }, 300);
    });
    await myPromise;

    setListLoading(false);

    // id:11
    // is_downloaded:0
    // orderId:"202604175"
    // orderdate:"17-04-2026"
    // supplierId:"48"
    // supplier_name: "TESTING SUPPLIER"
    // totalAmount: 22900
    // total_quantity: "20"

    if (ItemRadio == 1) {
      setPOpendingListOption(
        PopendingList?.map((item) => ({
          value: item.id,
          label: item?.orderId,
          date: item?.orderdate,
        })),
      );
    } else {
      setSupplydsgnList(
        SupplyDesignNameList?.map((item) => ({
          value: item.id,
          label: item.supply_design,
          design_no: item?.design_no,
          product: item?.product,
        })) || [],
      );
    }
    setprodList(
      ProductNameList?.map((item) => ({
        value: item.pdtid,
        label: item.pdt_code,
      })) || [],
    );
  };

  const handleListClose = () => {
    setListOpen(false);
    setdsgnList([]);
    setSupplydsgnList([]);
    setPOpendingListOption([]);
    setprodList([]);
  };

  const LedgerList = AccountNameList?.map((item) => ({
    value: item.id,
    label: item.company_name,
    address: item.address,
    mobile_no: item.mobile_no,
    GSTIN: item.GSTIN,
    PINCode: item.PINCode,
    et_state_id: item.et_state_id,
    state: item.state,
    et_city_id: item.et_city_id,
    city: item.city,
    et_broker_id: item.et_broker_id,
    broker: item.broker,
  }));

  const transList = TransportNameList?.map((item) => ({
    value: item.id,
    label: item.name,
  }));

  const barCodeList =
    BarcodeNameList?.map((item) => ({
      value: item.Barcode_ID,
      label: item.Barcode_BarcodeNo,
    })) || [];

  const ColorList = ColorNameList?.map((item) => ({
    value: item.mstcolour_id,
    label: item.mstcolour_name,
  }));

  const SizeList = SizeNameList?.map((item) => ({
    value: item.SizeId,
    label: item.SizeCode,
  }));

  const deleteFormData = (index) => {
    let itemDataArr = [...itemDataArray];
    itemDataArr.splice(index, 1);
    setitemDataArray(itemDataArr);
    handleModalCloseDelete();
  };

  const editFormData = async (item, isEdit) => {
    emptyFormData();
    if (item?.orderId || item?.orderdate) {
      setPOpendingID({ value: item.id, label: item?.orderId, date: item?.orderdate });
    }
    console.log({ POpendingID })
    setIsEditItemForm(isEdit);
    if (
      item?.colors?.find(
        (elem) => elem.color_name.toLowerCase() != "Mix".toLowerCase(),
      )
    ) {
      setIsClrSize(true);
    }
    setformDataItem({ ...item });
    setSuppDsgnNmCD(
      item?.design_id
        ? {
          value: item?.design_id,
          label: item?.supply_design,
          design_no: item?.design_no,
          product: item?.product,
        }
        : "",
    );
    setPodIdNme(
      item?.design_id
        ? {
          value: item?.product_id,
          label: item?.product,
        }
        : "",
    );
    setProductHSN(item?.hsn_code ? item?.hsn_code : "");
    setDsgRate(item?.rate ? item?.rate : "");

    let Rates = {
      cgst: 0,
      sgst: 0,
      igst: 0,
    };
    item?.gsttype?.map((itemm) => {
      Rates[itemm] = item?.[itemm];
    });
    setGstRates(Rates);

    let Data = await GetSupDesignDetails(item?.design_id, true);

    setUniqueSizes(Data?.usizes);
    const updatedRawClrSize = Data?.rawClrSize?.map((item1) => {
      const matchingColor = item?.colors?.find(
        (item2) => item2.color_name == item1.color_name,
      );
      if (matchingColor) {
        const updatedSizes = item1.sizes?.map((item3) => {
          const matchingSize = matchingColor.sizes.find(
            (item4) => item4.size_name === item3.size_name,
          );
          if (matchingSize) {
            return { ...item3, qty: matchingSize.size_qty };
          } else {
            return item3;
          }
        });

        return { ...item1, sizes: updatedSizes };
      } else {
        return item1;
      }
    });
    setRawClrSize(updatedRawClrSize);

    setDsgRate(item?.rate ? item?.rate : "");
    setDiscountPer(item?.discount_per ? item?.discount_per : "");
    setDiscountAmt(item?.discount_amount ? item?.discount_amount : "");
    setTotalQuantity(item?.qty ? item?.qty : "");
    setAmountBFT(item?.amountbft ? item?.amountbft : "");
    setcgstValue(item?.cgstamt ? item?.cgstamt : "");
    setsgstValue(item?.sgstamt ? item?.sgstamt : "");
    setigstValue(item?.igstamt ? item?.igstamt : "");
    setitemTotalAmt(item?.amount ? item?.amount : "");

    setShouldReRender(true);
    setTimeout(() => setShouldReRender(false), 1);
  };

  const emptyFormData = () => {
    setformDataItem({
      supplier_id: UserDetail?.result?.user?.id,
      supplier_name: UserDetail?.result?.user?.company_name,
      del_days: "",
      design_id: "",
      supply_design: "",
      design_no: "",
      design_desc: "",
      product: "",
      hsn_code: "",
      qty: 0,
      mtrs: "",
      rate: "",
      cgst: 0,
      sgst: 0,
      igst: 0,
      et_id: 0,
      gstper: 0,
      gsttype: [],
      totalgst: 0,
      remark: "",
      colors: [
        {
          qty: 0,
          sizes: [
            {
              qty: 0,
              sizeId: 1,
              size_name: "No Size",
              et_size_id: 0,
            },
          ],
          color_name: "Mix",
        },
      ],
      images: [],
    });

    setSuppDsgnNmCD();
    setPodIdNme();
    setProductHSN();
    setTotalQuantity();
    setDsgRate();
    setDiscountPer(UserDetail?.result?.user?.discount_per);
    setDiscountAmt();
    setIsDisAmt(false);
    setAmountBFT();
    setcgstValue();
    setsgstValue();
    setigstValue();
    setitemTotalAmt();
    setNewArray([]);
    setUniqueSizes([]);
    setRawClrSize([]);
    setIsClrSize(false);
    setGstRates({});
    setTaxRanges([]);
    itemButton?.blur();

    setShouldReRender(true);
    setTimeout(() => setShouldReRender(false), 1);
  };

  const [Led_StateID, setLed_StateID] = useState();

  // const GetDesignDetails = async (d, z) => {
  //   setLoader(true);
  //   var myHeaders = new Headers();
  //   myHeaders.append("Access-Control-Allow-Origin", "*");

  //   var raw = CustomStringify({
  //     Party_ID: Led_ID?.value,
  //     Party_StateID: Led_StateID,
  //     Type: "WS",
  //     TypeLevel: 1,
  //     Server: {
  //       Database: cmpdetail?.Database,
  //       Password: cmpdetail?.Password,
  //       Server: cmpdetail?.Server,
  //       User_ID: cmpdetail?.User_ID,
  //       Port: cmpdetail?.Port,
  //     },
  //   });

  //   var requestOptions = {
  //     method: "GET",
  //     headers: myHeaders,
  //     // body: raw,
  //     redirect: "follow",
  //   };

  //   const response = await fetch(
  //     `${API_URL}/products/colorstock/${cmpdetail?.key}/${d}?same_state=1`,
  //     requestOptions
  //   );
  //   const result = await response.json();

  //   if (result?.success == true) {
  //     setLoader(false);
  //     // setIsClrSize(true);
  //     setPodIdNme({
  //       value: result?.product_id,
  //       label: result?.product,
  //     });
  //     setProductHSN(result?.hsn_code);
  //     setDsgRate(result?.rate ? result?.rate : "");
  //     let Rates = {
  //       cgst: 0,
  //       sgst: 0,
  //       igst: 0,
  //     };
  //     result?.gsttype?.map((item) => {
  //       Rates[item] = result?.[item];
  //     });
  //     setGstRates(Rates);

  //     let usizes = result?.data?.reduce((acc, item) => {
  //       item?.sizes?.map((elem) => {
  //         if (acc.includes(elem?.size_name) == false) {
  //           acc.push(elem?.size_name);
  //         }
  //       })
  //       return acc;
  //     }, []);
  //     let rawClrSize = result?.data?.filter((item) => item?.color_name != "MIX");

  //     setUniqueSizes(usizes);
  //     setRawClrSize(rawClrSize);

  //     setformDataItem((prevData) => ({
  //       ...prevData,
  //       product: result?.product,
  //       hsn_code: result?.hsn_code,
  //       rate: result?.rate,
  //       cgst: result?.cgst,
  //       sgst: result?.sgst,
  //       igst: result?.igst,
  //       totalgst: result?.totalgst,
  //       gstper: result?.gstper,
  //       gsttype: result?.gsttype,
  //     }));

  //     setShouldReRender(true);
  //     setTimeout(() => setShouldReRender(false), 1);

  //     return { usizes, rawClrSize }
  //   } else {
  //     // showToast(result?.message, "error");
  //     setLoader(false);
  //   }
  // };

  const GetSupDesignDetails = async (d, edit) => {
    setLoader(true);
    var myHeaders = new Headers();
    myHeaders.append("Access-Control-Allow-Origin", "*");

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      // body: raw,
      redirect: "follow",
    };

    const response = await fetch(
      `${API_URL}/supplydesign/taxdetails/${d}/${cmpdetail?.key}`,
      requestOptions,
    );
    const result = await response.json();

    if (result?.success == true) {
      setLoader(false);
      if (!edit) {
        setQtyInputfocus(true);
        setPodIdNme({
          value: result?.data?.product_id,
          label: result?.data?.product,
        });
        setProductHSN(result?.data?.hsn_code);
        setDsgRate(result?.data?.base_rate ? result?.data?.base_rate : "");
        let Rates = {
          cgst: 0,
          sgst: 0,
          igst: 0,
        };
        result?.data?.gsttype?.map((item) => {
          Rates[item] = result?.data?.[item];
        });
        setGstRates(Rates);
        setTaxRanges(result?.data?.tax_details);

        let usizes = result?.data?.colorsizes?.reduce((acc, item) => {
          item?.sizes?.map((elem) => {
            if (acc.includes(elem?.size_name) == false) {
              acc.push(elem?.size_name);
            }
          });
          return acc;
        }, []);
        let rawClrSize = result?.data?.colorsizes;

        setUniqueSizes(usizes);
        setRawClrSize(rawClrSize);

        setformDataItem((prevData) => ({
          ...prevData,
          product: result?.data?.product,
          hsn_code: result?.data?.hsn_code,
          rate: result?.data?.base_rate,
          cgst: result?.data?.cgst,
          sgst: result?.data?.sgst,
          igst: result?.data?.igst,
          totalgst: result?.data?.totalgst,
          gstper: result?.data?.gstper,
          gsttype: result?.data?.gsttype,
        }));
      } else {
        setTaxRanges(result?.data?.tax_details);
        let usizes = result?.data?.colorsizes?.reduce((acc, item) => {
          item?.sizes?.map((elem) => {
            if (acc.includes(elem?.size_name) == false) {
              acc.push(elem?.size_name);
            }
          });
          return acc;
        }, []);
        let rawClrSize = result?.data?.colorsizes;

        return { usizes, rawClrSize };
      }

      setShouldReRender(true);
      setTimeout(() => setShouldReRender(false), 1);
    } else {
      showToast(result?.message, "error");
      setLoader(false);
    }
  };

  const handleTrp_ID = async (Trp_ID) => {
    setTrp_ID(Trp_ID);
  };

  const [showItemDataArray, setshowItemDataArray] = useState([]);
  console.log(showItemDataArray, "showItemDataArray");

  const handlePOpending_ID = async (ID) => {
    setPOpendingID(ID);

    try {
      let res = await GET(`/purchaseorders/detailforvendor/demo/${ID?.value}`);

      // 1. Flatten the incoming data from the API
      console.log(res.data, "res.datares.data", itemDataArray);
      let rawFinalData = res.data.flatMap((item) =>
        item.OrderDesign.map((design) => ({
          ...design,
          orderdate: item.orderdate,
          orderId: item.orderId,
        })),
      );

      // 2. Process finalData by checking against itemDataArray
      const processedData = rawFinalData
        .map((finalItem) => {
          // Deep clone the item to avoid mutating the original response
          let item = JSON.parse(JSON.stringify(finalItem));


          const matchingDesigns = itemDataArray.filter(
            // (orig) => orig.design_id === item.id || orig.id === item.id
            (orig) => orig?.id === item.id && orig?.orderId == item.orderId,
          );

          if (matchingDesigns.length > 0) {
            item.colors = item.colors
              .map((finalColor) => {

                finalColor.sizes = finalColor.sizes
                  .map((finalSize) => {

                    let usedQty = 0;

                    matchingDesigns.forEach((designEntry) => {
                      const matchedColors = designEntry.colors?.filter(
                        (c) => c.colorId === finalColor.colorId
                      );

                      matchedColors?.forEach((c) => {
                        const matchedSize = c.sizes?.find(
                          (s) => s.sizeId === finalSize.sizeId
                        );

                        if (matchedSize) {
                          // ✅ IMPORTANT CHANGE: use qty (not size_qty)
                          usedQty += Number(matchedSize.qty || 0);
                        }
                      });
                    });

                    const remaining =
                      Number(finalSize.bal_qty || 0) - usedQty;

                    return {
                      ...finalSize,
                      bal_qty: remaining < 0 ? 0 : remaining,
                      qty: remaining < 0 ? 0 : remaining, // Add this line to set qty based on remaining
                    };
                  })
                  .filter((s) => (s.bal_qty ?? 0) > 0);

                // ✅ color total based on remaining stock
                finalColor.qty = finalColor.sizes.reduce(
                  (acc, s) => acc + Number(s.bal_qty || 0),
                  0
                );

                return finalColor;
              })
              .filter((c) => c.sizes.length > 0);
            // UPDATE: Recalculate design-level total qty
            item.qty = item.colors.reduce((acc, c) => acc + c.qty, 0);
          }

          return item;
        })
        // FILTER: Remove the whole design if no colors/quantities remain
        .filter((item) => item.colors && item.colors.length > 0);

      // 3. Update the state with the filtered data
      setshowItemDataArray(processedData);
    } catch (err) {
      console.error("Error in handlePOpending_ID:", err);
    }

    emptyFormData();
    setModalOpenSecond(true);
  };
  // const handlePOpending_ID = async (ID) => {
  //   setPOpendingID(ID);

  //   try {
  //     let res = await GET(`/purchaseorders/detailforvendor/demo/${ID?.value}`);
  //     console.log(res.data, "Deep");

  //     const finalData = res.data.flatMap((item) =>
  //       item.OrderDesign.map((design) => ({
  //         ...design,
  //         orderdate: item.orderdate,
  //         orderId: item.orderId,
  //       })),
  //     );

  //     setshowItemDataArray(finalData);
  //   } catch (err) {
  //     console.error(err);
  //   }

  //   emptyFormData();
  //   setModalOpenSecond(true);
  // };

  const handleSupDsnCode_ID = async (Desg_ID) => {
    console.log(Desg_ID, "Desg_ID");
    if (Desg_ID?.value == 0) {
      setDesignName(Desg_ID?.label?.replaceAll('"', "").replaceAll("Add ", ""));
      handleModalOpenAddNew();
    } else {
      if (
        itemDataArray
          ?.map((ele) => ele?.supply_design)
          ?.includes(Desg_ID?.label)
      ) {
        return showToast("Design Already Exists", "error");
      }

      emptyFormData();
      setSuppDsgnNmCD(Desg_ID);
      await GetSupDesignDetails(Desg_ID?.value);
      setformDataItem((prevData) => ({
        ...prevData,
        design_id: Desg_ID?.value,
        supply_design: Desg_ID?.label,
        design_no: Desg_ID?.design_no,
      }));
    }
  };

  const handleQuantity = (event) => {
    const { name, value } = event.target;
    calculateFormDataAmount(
      Number(value),
      DsgRate,
      DiscountPer,
      isDisAmt,
      GstRates,
    );
    setformDataItem((prevData) => ({ ...prevData, qty: value }));
    setRawClrSize((pre) => {
      return pre?.map((item) => {
        return {
          ...item,
          sizes: item?.sizes?.map((elem) => {
            let obj = elem;
            delete obj.qty;
            return obj;
          }),
        };
      });
    });
  };

  const DiscountedRate = (rate, disPer) => {
    let discountedRatee = (rate || 0) - (disPer / 100) * (rate || 0);
    let discountedRate =
      discountedRatee > 999 && discountedRatee < 1000
        ? Math.round(discountedRatee)
        : discountedRatee;
    return discountedRate;
  };

  const handleRateChange = (e) => {
    const { name, value } = e.target;
    setDsgRate(value);
    setformDataItem((prevData) => ({ ...prevData, rate: value }));

    let newTax = TaxRanges?.find((item) => {
      return (
        DiscountedRate(value, DiscountPer) >= item?.from &&
        DiscountedRate(value, DiscountPer) <= item?.to
      );
    });

    let Rates = {
      cgst: 0,
      sgst: 0,
      igst: 0,
    };
    formDataItem?.gsttype?.map((item) => {
      Rates[item] = newTax?.[item];
    });

    setformDataItem((prevData) => ({
      ...prevData,
      cgst: newTax?.cgst,
      sgst: newTax?.sgst,
      igst: newTax?.igst,
      totalgst: Rates.cgst + Rates.sgst + Rates.igst,
      gstper: Rates.cgst + Rates.sgst + Rates.igst,
    }));
    calculateFormDataAmount(
      TotalQuantity,
      Number(value),
      DiscountPer,
      isDisAmt,
      Rates,
    );
  };

  const handleDiscountPer = (event) => {
    let DisPer = event.target.value;
    setDiscountPer(DisPer);
    setformDataItem((prevData) => ({ ...prevData, discount_per: DisPer }));

    let newTax = TaxRanges?.find((item) => {
      return (
        DiscountedRate(DsgRate, DisPer) >= item?.from &&
        DiscountedRate(DsgRate, DisPer) <= item?.to
      );
    });

    let Rates = {
      cgst: 0,
      sgst: 0,
      igst: 0,
    };
    formDataItem?.gsttype?.map((item) => {
      Rates[item] = newTax?.[item];
    });

    setformDataItem((prevData) => ({
      ...prevData,
      cgst: newTax?.cgst,
      sgst: newTax?.sgst,
      igst: newTax?.igst,
      totalgst: Rates.cgst + Rates.sgst + Rates.igst,
      gstper: Rates.cgst + Rates.sgst + Rates.igst,
    }));
    calculateFormDataAmount(TotalQuantity, DsgRate, DisPer, isDisAmt, Rates);
  };

  const handleDiscountAmt = (event) => {
    let DisAmt = event.target.value;
    setDiscountAmt(DisAmt);
    setformDataItem((prevData) => ({ ...prevData, discount_amount: DisAmt }));

    let disPerr = (DisAmt / AmountBFT) * 100;
    let disPer = disPerr == Infinity ? 0 : disPerr?.toFixed(2);
    let newTax = TaxRanges?.find((item) => {
      return (
        DiscountedRate(DsgRate, disPer) >= item?.from &&
        DiscountedRate(DsgRate, disPer) <= item?.to
      );
    });

    let Rates = {
      cgst: 0,
      sgst: 0,
      igst: 0,
    };
    formDataItem?.gsttype?.map((item) => {
      Rates[item] = newTax?.[item];
    });

    setformDataItem((prevData) => ({
      ...prevData,
      cgst: newTax?.cgst,
      sgst: newTax?.sgst,
      igst: newTax?.igst,
      totalgst: Rates.cgst + Rates.sgst + Rates.igst,
      gstper: Rates.cgst + Rates.sgst + Rates.igst,
    }));
    calculateFormDataAmount(TotalQuantity, DsgRate, DisAmt, isDisAmt, Rates);
  };

  const calculateFormDataAmount = (Qty, Rate, Discount, isDisAmt, gstRates) => {
    let TotalQ = Qty;
    setTotalQuantity(TotalQ);
    let AmountBf = (TotalQ ? TotalQ : 0) * (Rate ? Rate : 0);
    if (isDisAmt) {
      var DisPer = (Discount / AmountBf) * 100;
      setDiscountPer(DisPer == Infinity ? 0 : DisPer?.toFixed(2));
      var DisAmt = Discount;
    } else {
      var DisAmt = AmountBf * (Discount ? Discount / 100 : 0);
      setDiscountAmt(Number(DisAmt)?.toFixed(2));
    }

    AmountBf = AmountBf - DisAmt;
    setAmountBFT(AmountBf?.toFixed(2));

    setGstRates(gstRates);
    let cgstVal = AmountBf * ((gstRates?.cgst ? gstRates?.cgst : 0) / 100);
    let sgstVal = AmountBf * ((gstRates?.sgst ? gstRates?.sgst : 0) / 100);
    let igstVal = AmountBf * ((gstRates?.igst ? gstRates?.igst : 0) / 100);
    setcgstValue(cgstVal?.toFixed(2));
    setsgstValue(sgstVal?.toFixed(2));
    setigstValue(igstVal?.toFixed(2));
    const itemTotAmt =
      Number(AmountBf) + Number(cgstVal) + Number(sgstVal) + Number(igstVal);
    setitemTotalAmt(itemTotAmt?.toFixed(2));
  };

  const insertPackingChallan = async () => {
    if (!BillNo) {
      return showToast("Please Enter Bill No.", "error");
    } else if (!BillDate) {
      return showToast("Please Enter Bill Date", "error");
    }

    setLoader(true);
    var myHeaders = new Headers();
    myHeaders.append("Access-Control-Allow-Origin", "*");

    const formData = new FormData();

    formData.append("et_ledger_id", 0);
    formData.append("supplierId", Led_ID?.value ? Led_ID?.value : "");
    formData.append("party", Led_ID?.label ? Led_ID?.label : "");
    formData.append("supplier_name", Led_ID?.label ? Led_ID?.label : "");
    formData.append("address", Led_ID?.address ? Led_ID?.address : "");
    formData.append("mobile_no", Led_ID?.mobile_no ? Led_ID?.mobile_no : "");
    formData.append("GSTIN", Led_ID?.GSTIN ? Led_ID?.GSTIN : "");
    formData.append("PINCode", Led_ID?.PINCode ? Led_ID?.PINCode : "");
    formData.append("et_state_id",Led_ID?.et_state_id ? Led_ID?.et_state_id : "",);
    formData.append("state", Led_ID?.state ? Led_ID?.state : "");
    formData.append("et_city_id", Led_ID?.et_city_id ? Led_ID?.et_city_id : "");
    formData.append("city", Led_ID?.city ? Led_ID?.city : "");
    formData.append("et_broker_id",Led_ID?.et_broker_id ? Led_ID?.et_broker_id : "",);
    formData.append("broker", Led_ID?.broker ? Led_ID?.broker : "");
    formData.append("bill_no", BillNo ? BillNo : "");
    formData.append("bill_date", BillDate ? BillDate : "");
    formData.append("et_transport_id", Trp_ID?.value ? Trp_ID?.value : "");
    formData.append("transport", Trp_ID?.label ? Trp_ID?.label : "");
    formData.append("total_quantity", mainTotalQty);
    formData.append("discount_amount", mainTotalDiscount);
    formData.append("totalAmount", mainTotalTaxableAmt);
    formData.append(
      "gst_amount",
      Number(mainTotalItemCgst) +
      Number(mainTotalItemSgst) +
      Number(mainTotalItemIgst),
    );
    formData.append("net_amount", mainTotalAmount);
    formData.append("OrderDesign", JSON.stringify(itemDataArray));

    formData.append("orderId", 0);
    formData.append("orderdate", 0);
    formData.append("order_no", 0);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formData,
      redirect: "follow",
    };

    fetch(`${API_URL}/purchase/${cmpdetail?.key}`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result?.success === true) {
          setLoader(false);
          navigate("/PackingChallan", {
            state: "Packing Challan Added Successfully",
          });
        } else {
          setLoader(false);
          showToast(result?.message, "error");
        }
      })
      .catch((error) => {
        setLoader(false);
        showToast("API Error", "error");
        console.log(error);
      });
  };

  const ClrSizehandler = async (event) => {
    const { name, value } = event.target;
    const [colorName, sizename] = name.split(".");

    let newRawClrSize = RawClrSize.map((elem) => {
      if (elem?.color_name == colorName) {
        return {
          ...elem,
          sizes: elem?.sizes?.map((ele) => {
            if (ele?.size_name == sizename) {
              return {
                ...ele,
                qty: Number(value),
              };
            } else {
              return ele;
            }
          }),
        };
      } else {
        return elem;
      }
    });

    setRawClrSize(newRawClrSize);

    let Qty = newRawClrSize?.reduce((acc, item) => {
      let newac = item?.sizes?.reduce((ac, elem) => {
        return ac + Number(elem?.qty || 0);
      }, 0);

      return acc + newac;
    }, 0);

    calculateFormDataAmount(Qty, DsgRate, DiscountPer, isDisAmt, GstRates);
  };

  const setMainTotalData = () => {
    var mainTotQty = 0;
    var mainTotDis = 0;
    var mainTotTaxAmt = 0;
    var mainTotItemCgst = 0;
    var mainTotItemSgst = 0;
    var mainTotItemIgst = 0;
    var mainTotAmt = 0;
    itemDataArray?.map((item) => {
      mainTotQty = mainTotQty + Number(item?.qty);
      mainTotDis = mainTotDis + Number(item?.discount_amount);
      mainTotTaxAmt = mainTotTaxAmt + Number(item?.amountbft);
      mainTotItemCgst = mainTotItemCgst + Number(item?.cgstamt);
      mainTotItemSgst = mainTotItemSgst + Number(item?.sgstamt);
      mainTotItemIgst = mainTotItemIgst + Number(item?.igstamt);
      mainTotAmt = mainTotAmt + Number(item?.amount);
    });

    setMainTotalQty(mainTotQty?.toFixed(2));
    setMainTotalDiscount(mainTotDis?.toFixed(2));
    setMainTotalTaxableAmt(mainTotTaxAmt?.toFixed(2));
    setMainTotalItemCgst(mainTotItemCgst?.toFixed(2));
    setMainTotalItemSgst(mainTotItemSgst?.toFixed(2));
    setMainTotalItemIgst(mainTotItemIgst?.toFixed(2));
    setMainTotalAmount(mainTotAmt?.toFixed(2));
  };

  const MakeColorsArr = (arr, clrsize) => {
    if (clrsize) {
      return arr
        ?.map((item) => {
          if (
            item?.sizes?.reduce((acc, el) => {
              return acc + Number(el?.qty || 0);
            }, 0) > 0
          ) {
            return {
              ...item,
              qty: item?.sizes?.reduce((acc, el) => {
                return acc + Number(el?.qty || 0);
              }, 0),
              sizes: item?.sizes
                ?.map((elem) => {
                  if (elem?.qty) {
                    return {
                      ...elem,
                    };
                  } else {
                    return null;
                  }
                })
                ?.filter((e) => e != null),
            };
          } else {
            return null;
          }
        })
        ?.filter((e) => e != null);
    } else {
      return [
        {
          designId: 84,
          supply_design: SuppDsgnNmCD?.label,
          design_no: SuppDsgnNmCD?.design_no,
          product: SuppDsgnNmCD?.product,
          colorId: 0,
          color_name: "Mix",
          et_color_id: 0,
          qty: TotalQuantity,
          sizes: [
            {
              sizeId: 1,
              size_name: "No Size",
              et_size_id: 0,
              qty: TotalQuantity,
            },
          ],
        },
      ];
    }
  };

  const handleAddItemDetail = (id, Qty, Rate) => {
    if (Qty) {
      if (Rate) {
        if (Number(cgstValue) || Number(sgstValue) || Number(igstValue)) {
          setitemDataArray((prevArray) => [
            ...prevArray,
            {
              ...formDataItem,
              colors: MakeColorsArr(
                RawClrSize,
                RawClrSize?.length > 0 && IsClrSize,
              ),
            },
          ]);
          setRowId(id + 1);
          emptyFormData();
          setMainTotalData();
        } else {
          showToast("GST Not Found", "error");
        }
      } else {
        showToast("Please Add Rate", "error");
      }
    } else {
      showToast("Please Add Quantity", "error");
    }
  };

  const handleUpdateItemDetail = (index, Qty, Rate) => {
    if (Qty) {
      if (Rate) {
        if (Number(cgstValue) || Number(sgstValue) || Number(igstValue)) {
          setitemDataArray((prevArray) => [
            ...prevArray?.filter((item, i) => i != index),
            {
              ...formDataItem,
              colors: MakeColorsArr(
                RawClrSize,
                RawClrSize?.length > 0 && IsClrSize,
              ),
            },
          ]);
          emptyFormData();
          setMainTotalData();
          setIsEditItemForm(false);
          setIsClrSize(false);
          handleModalClose();
        } else {
          showToast("GST Not Found", "error");
        }
      } else {
        showToast("Please Add Rate", "error");
      }
    } else {
      showToast("Please Add Quantity", "error");
    }
  };

  useEffect(() => {
    setMainTotalData();
  }, [itemDataArray]);

  useEffect(() => {
    dispatch(fetchPOpendingList({ cmpdetail, UserDetail }));
  }, [cmpdetail, UserDetail]);

  useEffect(() => {
    setformDataItem((prevData) => ({
      ...prevData,
      design_id: SuppDsgnNmCD?.value != undefined ? SuppDsgnNmCD?.value : "",
    }));
    setformDataItem((prevData) => ({
      ...prevData,
      product_id: PodIdNme?.value != undefined ? PodIdNme?.value : "",
    }));
    setformDataItem((prevData) => ({
      ...prevData,
      hsn_code: ProductHSN != undefined ? ProductHSN : "",
    }));
    setformDataItem((prevData) => ({
      ...prevData,
      qty: TotalQuantity != undefined ? TotalQuantity : "",
    }));
    setformDataItem((prevData) => ({
      ...prevData,
      rate: DsgRate != undefined ? DsgRate : "",
    }));
    setformDataItem((prevData) => ({
      ...prevData,
      discount_per: DiscountPer != undefined ? DiscountPer : "",
    }));
    setformDataItem((prevData) => ({
      ...prevData,
      discount_amount: DiscountAmt != undefined ? DiscountAmt : "",
    }));
    setformDataItem((prevData) => ({
      ...prevData,
      amountbft: AmountBFT != undefined ? AmountBFT : "",
    }));
    setformDataItem((prevData) => ({
      ...prevData,
      cgstamt: cgstValue != undefined ? cgstValue : "",
    }));
    setformDataItem((prevData) => ({
      ...prevData,
      sgstamt: sgstValue != undefined ? sgstValue : "",
    }));
    setformDataItem((prevData) => ({
      ...prevData,
      igstamt: igstValue != undefined ? igstValue : "",
    }));
    setformDataItem((prevData) => ({
      ...prevData,
      amount: itemTotalAmt != undefined ? itemTotalAmt : "",
    }));
  }, [
    SuppDsgnNmCD,
    PodIdNme,
    ProductHSN,
    TotalQuantity,
    DsgRate,
    DiscountPer,
    DiscountAmt,
    AmountBFT,
    cgstValue,
    sgstValue,
    igstValue,
    itemTotalAmt,
  ]);

  const sizeName = (id) => {
    let name = SizeAll?.filter((item) => {
      return item?.SizeId == id;
    })[0]?.SizeCode;
    return id == 0 ? "Mix" : name ? name : "";
  };

  const ColorHex = (id) => {
    return ColorNameList?.find((item) => {
      return item?.mstcolour_id == id;
    })?.mstcolour_hex;
  };
  const colorName = (id) => {
    let name = ColorAll?.filter((item) => {
      return item?.mstcolour_id == id;
    })[0]?.mstcolour_name;
    return name ? name : "";
  };

  const unitName = (id) => {
    let name = UnitNameList?.filter((item) => {
      return item?.UnitId == id;
    })[0]?.UnitName;
    return name ? name : "";
  };

  const szId = (name) => {
    let id = SizeAll?.filter((item) => {
      return item?.SizeCode == name;
    })[0]?.SizeId;
    return name == "Mix" ? 0 : id ? id : "";
  };

  const clrId = (name) => {
    let id = ColorAll?.filter((item) => {
      return item?.mstcolour_name == name;
    })[0]?.mstcolour_id;
    return id ? id : "";
  };

  const IsMtrs = (id) => {
    let mtrs =
      UnitNameList?.filter((item) => {
        return item?.UnitId == id;
      })[0]?.Unit_UQId == 24;
    return mtrs;
  };

  useEffect(() => {
    const getDate = (Date) => {
      const today = Date;
      const year = today.getFullYear();
      const month = (today.getMonth() + 1).toString().padStart(2, "0");
      const day = today.getDate().toString().padStart(2, "0");
      return `${year}-${month}-${day}`;
    };

    setBillDate(getDate(new Date()));
  }, []);

  useEffect(() => {
    dispatch(fetchListAC(cmpdetail));
    dispatch(fetchListAgent(cmpdetail));
    dispatch(fetchListTrans(cmpdetail));
    dispatch(fetchListTMBR(cmpdetail));
    dispatch(fetchListSUPFG({ cmpdetail, UserDetail }));
    setLed_ID({
      value: UserDetail?.result?.user?.id,
      label: UserDetail?.result?.user?.company_name,
    });
    setTrp_ID({
      value: UserDetail?.result?.user?.et_transport_id,
      label: UserDetail?.result?.user?.transport,
    });

    setShouldReRender(true);
    setTimeout(() => setShouldReRender(false), 1);
  }, []);

  useEffect(() => {
    setTimeout(() => {
      function focusNextEmptyInput(currentIndex, inputs) {
        for (let i = currentIndex + 1; i < inputs.length; i++) {
          if (!inputs[i].value) {
            inputs[i].focus();
            return;
          }
        }
      }

      var inputs = document.querySelectorAll("input:enabled");

      inputs.forEach((input, index) => {
        input.addEventListener("focus", function (event) {
          if (event.target.type == "checkbox") {
            var nextIndex = index + 1;
            if (nextIndex < inputs?.length) {
              inputs[nextIndex].focus();
            }
          }
        });
        input.addEventListener("keydown", function (event) {
          if (event.key === "Enter") {
            event.preventDefault();
            if (
              event.target.id == "Discount%" ||
              (event.target.id == "Rate" &&
                document.getElementById("Discount%")?.value) ||
              (event.target.id == "Qty" &&
                document.getElementById("Rate")?.value &&
                document.getElementById("Discount%")?.value)
            ) {
              itemButton?.focus();
            } else if (event.target.id.indexOf("Autocomplete") == -1) {
              focusNextEmptyInput(index, inputs);
            } else {
              if (event.target.ariaExpanded == "false") {
                focusNextEmptyInput(index, inputs);
              }
            }
          }
        });
      });
    }, 500);
  });

  useEffect(() => {
    const keyEnter = (event) => {
      if (event.altKey) {
        event.preventDefault();
        switch (event.key) {
          case "n":
            handleModalOpen();
            break;
          case "a":
            if (isEditItemForm) {
              handleUpdateItemDetail(itemIndex, TotalQuantity, DsgRate);
            } else {
              handleAddItemDetail(rowId, TotalQuantity, DsgRate);
            }
            break;
          case "s":
            insertPackingChallan();
            break;
          case "e":
            handleModalClose();
            break;
          default:
            break;
        }
      }
    };

    document.addEventListener("keydown", keyEnter);

    return () => {
      document.removeEventListener("keydown", keyEnter);
    };
  });

  const theme = createTheme({
    palette: {
      primary: {
        main: Theme.primaryThemeColor,
      },
    },
    typography: {
      fontFamily: "Poppins",
      h6: {
        "@media (max-width: 450px)": {
          fontSize: "16px",
        },
      },
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            color: "#fff",
            fontSize: "12.5px",
            maxWidth: "260px",
            height: "16px",
            padding: "12px 8px 11px 8px",
            fontWeight: 500,
            "@media (max-width: 450px)": {
              fontSize: "11px",
              padding: "11px 6px 10px 6px",
            },
          },
        },
      },
    },
  });

  const form = createTheme({
    palette: {
      primary: {
        main: Theme.primaryThemeColor,
      },
    },
    typography: {
      fontFamily: "Poppins",
    },
    components: {
      MuiInputBase: {
        styleOverrides: {
          root: {
            fontSize: "13px",
            height: "35px",
          },
        },
      },
      MuiInputLabel: {
        styleOverrides: {
          root: {
            fontSize: "14px",
            marginTop: "-8px",
          },
        },
      },
      MuiAutocomplete: {
        styleOverrides: {
          input: {
            marginTop: "-8px",
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            color: "#fff",
            fontSize: "12.5px",
            maxWidth: "260px",
            height: "35px",
            padding: "0px 8px 0px 8px",
            fontWeight: 500,
          },
        },
      },
      MuiTabs: {
        styleOverrides: {
          root: {
            padding: 0,
            minHeight: 30,
          },
        },
      },
      MuiTab: {
        styleOverrides: {
          root: {
            fontSize: "13px",
            fontWeight: 500,
            padding: 0,
            minHeight: 30,
            "&.Mui-selected": {
              backgroundColor: Theme.primaryThemeColor,
              color: "white",
              borderRadius: "5px",
            },
          },
        },
      },
      MuiTableCell: {
        styleOverrides: {
          root: {
            borderBottom: "1px solid #9a9da1",
          },
          head: {
            "&::after": {
              content: '""',
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: hexToRGBFade(Theme.primaryThemeColor, 0.4),
              zIndex: -1,
            },
            whiteSpace: "nowrap",
            width: "auto",
          },
          body: {
            whiteSpace: "nowrap",
            width: "auto",
          },
        },
      },
    },
  });

  const innerformClr = createTheme({
    palette: {
      primary: {
        main: Theme.primaryThemeColor,
      },
    },
    typography: {
      fontFamily: "Poppins",
    },
    components: {
      MuiInputBase: {
        styleOverrides: {
          root: {
            fontSize: "13px",
            height: "30px",
            width: "100px",
          },
        },
      },
      MuiInputLabel: {
        styleOverrides: {
          root: {
            marginTop: "-10px",
            fontSize: "14px",
          },
        },
      },
      MuiAutocomplete: {
        styleOverrides: {
          input: {
            marginTop: "-5px",
          },
        },
      },
      MuiTableCell: {
        styleOverrides: {
          head: {
            fontWeight: "600",
            fontSize: "14px",
          },
        },
      },
    },
  });

  return (
    <>
      <div className="main-box">
        <ThemeProvider theme={theme}>
          <Typography variant="h6" sx={{ px: 2 }}>
            {cmpdetail?.company_name}
          </Typography>
          <div className="box-head transaction-add">
            <Stack className="heading" alignItems="center" direction="row">
              <IconButton
                color="primary"
                onClick={() => {
                  navigate(-1);
                }}
              >
                <ArrowBackIosIcon sx={{ fontSize: "20px" }} />
              </IconButton>
              <Typography variant="h6">Packing Challan</Typography>
            </Stack>
            <Stack className="" alignItems="center" direction="row">
              <Button onClick={insertPackingChallan} variant="contained">
                Save
              </Button>
            </Stack>
          </div>
          <Backdrop sx={{ color: "#fff", zIndex: 9999 }} open={Loader}>
            <CircularProgress color="inherit" />
          </Backdrop>
          <Dialog
            onClose={handleModalCloseAddNew}
            open={modalOpenAddNew}
            maxWidth={"lg"}
            sx={{
              "& .MuiDialog-paper": {
                width: "100vw",
                mt: -3,
              },
            }}
          >
            <DialogTitle sx={{ p: 0, display: "flex", justifyContent: "end" }}>
              <IconButton aria-label="close" onClick={handleModalCloseAddNew}>
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent sx={{ p: 0 }}>
              {DesignName ? (
                <AddFGDesign
                  Name={DesignName}
                  handleModalCloseAddNew={(event, Desg_ID) =>
                    handleModalCloseAddNew(event, Desg_ID)
                  }
                  setLoaderAddNew={(newVal) => setLoader(newVal)}
                />
              ) : (
                <></>
              )}
            </DialogContent>
          </Dialog>
          <DeleteDialog
            modalOpen={modalOpenDelete}
            handleModalClose={() => handleModalCloseDelete()}
            executeConfirmed={() => deleteFormData(itemIndex)}
          />
          <div className="card-form-box addtxn">
            <ThemeProvider theme={form}>
              <Paper
                sx={{
                  width: "100%",
                  height: "60px",
                  display: "flex",
                  flexDirection: "column",
                  alignContent: "center",
                  overflowY: "scroll",
                  "::-webkit-scrollbar": {
                    display: "none",
                  },
                  py: 1,
                  transition: "0.5s ease-in-out",
                }}
              >
                <Grid
                  container
                  spacing={1.3}
                  columns={12}
                  sx={{ mt: 0.1, width: "100%", padding: "0 10px 0 10px" }}
                >
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={4}
                    lg={4}
                    sx={{ display: "flex", justifyContent: "center" }}
                  >
                    <TextField
                      id="BillNo."
                      label="Bill No."
                      value={BillNo}
                      onChange={(event) => {
                        setBillNo(event.target.value);
                      }}
                      InputLabelProps={{
                        shrink: BillNo != undefined ? true : false,
                      }}
                      sx={{ width: "100%" }}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={4}
                    lg={4}
                    sx={{ display: "flex", justifyContent: "center" }}
                  >
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        disableFuture
                        // maxDate={dayjs(cmpdetail?.ExpiryDate)}
                        format="DD/MM/YYYY"
                        label="Bill Date"
                        value={BillDate ? dayjs(BillDate) : null}
                        onChange={(newValue) => {
                          return setBillDate(newValue.format("YYYY-MM-DD"));
                        }}
                        InputLabelProps={{
                          shrink: BillDate != undefined ? true : false,
                        }}
                        sx={{ width: "100%" }}
                      />
                    </LocalizationProvider>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={4}
                    lg={4}
                    sx={{ display: "flex", justifyContent: "center" }}
                  >
                    {shouldReRender ? (
                      <Autocomplete
                        disableClearable
                        id="Mui-Autocomplete-TransportName"
                        sx={{ width: "100%" }}
                        renderInput={(params) => (
                          <TextField {...params} label="Transport Name" />
                        )}
                      />
                    ) : null}
                    {!shouldReRender && (
                      <Autocomplete
                        disableClearable
                        id="Mui-Autocomplete-TransportName"
                        value={Trp_ID}
                        onChange={(event, newValue) => {
                          handleTrp_ID(newValue);
                        }}
                        options={transList?.sort(sortByLabel)}
                        renderOption={(props, item) => (
                          <li {...props} key={item.value}>
                            {item.label}
                          </li>
                        )}
                        filterOptions={(options, params) => {
                          const filtered = filter(options, params);
                          if (
                            params.inputValue !== "" &&
                            filtered?.length < 1
                          ) {
                            filtered.push({
                              label: `Add "${params.inputValue}"`,
                              value: 0,
                            });
                          }
                          return filtered;
                        }}
                        getOptionLabel={(option) =>
                          option.label ? option.label : ""
                        }
                        isOptionEqualToValue={(option, value) =>
                          option?.value === value?.value
                        }
                        sx={{ width: "100%" }}
                        renderInput={(params) => (
                          <TextField {...params} label="Transport Name" />
                        )}
                      />
                    )}
                  </Grid>
                </Grid>
              </Paper>
              <Box
                sx={{
                  width: "100%",
                  height: "calc(100% - 60px)",
                  bgcolor: "background.paper",
                  transition: "0.5s ease-in-out",
                }}
              >
                <TabContext value={tabValue}>
                  <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                    <TabList
                      onChange={handleTabChange}
                      variant="fullWidth"
                      aria-label="lab API tabs example"
                      sx={{ background: "#eaebee" }}
                    >
                      <Tab label="Item Detail" value="1" />
                      {/* <Tab label="Sundry Detail" value="2" /> */}
                    </TabList>
                  </Box>
                  <TabPanel value="1" sx={{ height: "100%", m: 0, p: 0 }}>
                    <TableContainer component={Paper} sx={{ maxHeight: "96%" }}>
                      <Table
                        stickyHeader
                        sx={{ minWidth: 650 }}
                        size="small"
                        aria-label="a dense table"
                      >
                        <TableHead>
                          <TableRow>
                            <TableCell sx={{ fontWeight: 600 }}>
                              <Tooltip title="Add Item">
                                <IconButton
                                  aria-label="Add"
                                  color="primary"
                                  onClick={handleModalOpen}
                                  sx={{ padding: 0, margin: 0 }}
                                >
                                  <AddCircleOutlinedIcon
                                    sx={{ fontSize: "20px" }}
                                  />
                                </IconButton>
                              </Tooltip>
                            </TableCell>
                            <TableCell sx={{ fontWeight: 600 }}>SR#</TableCell>
                            <TableCell sx={{ fontWeight: 600 }}>
                              Supply Design
                            </TableCell>
                            <TableCell sx={{ fontWeight: 600 }}>
                              Design
                            </TableCell>
                            <TableCell sx={{ fontWeight: 600 }}>
                              Product
                            </TableCell>
                            <TableCell sx={{ fontWeight: 600 }}>Qty</TableCell>
                            <TableCell sx={{ fontWeight: 600 }}>Rate</TableCell>
                            <TableCell
                              colSpan={2}
                              align="center"
                              sx={{ fontWeight: 600 }}
                            >
                              Discount
                            </TableCell>
                            <TableCell sx={{ fontWeight: 600 }}>
                              Taxable Amt
                            </TableCell>
                            <TableCell sx={{ fontWeight: 600 }}></TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {itemDataArray?.map((item, index) => (
                            <TableRow key={index}>
                              <TableCell sx={{ py: 0.5 }}>
                                <Tooltip title="Edit Item">
                                  <IconButton
                                    color="primary"
                                    aria-label="Edit"
                                    onClick={() => {
                                      handleModalEdit(item, index);
                                    }}
                                    sx={{ padding: 0, margin: 0 }}
                                  >
                                    <ModeEditIcon sx={{ fontSize: "20px" }} />
                                  </IconButton>
                                </Tooltip>
                              </TableCell>
                              <TableCell sx={{ py: 0.5 }}>
                                {index + 1}
                              </TableCell>
                              <TableCell sx={{ py: 0.5 }}>
                                {item?.supply_design}
                              </TableCell>
                              <TableCell sx={{ py: 0.5 }}>
                                {item?.design_no}
                              </TableCell>
                              <TableCell sx={{ py: 0.5 }}>
                                {item?.product}
                              </TableCell>
                              <TableCell sx={{ py: 0.5 }}>
                                {item?.qty}
                              </TableCell>
                              <TableCell sx={{ py: 0.5 }}>
                                {item?.rate}
                              </TableCell>
                              <TableCell align="center" sx={{ py: 0.5 }}>
                                <b>
                                  {item?.discount_per
                                    ? item?.discount_per + "%"
                                    : ""}
                                </b>
                              </TableCell>
                              <TableCell align="center" sx={{ py: 0.5 }}>
                                {item?.discount_amount
                                  ? item?.discount_amount
                                  : ""}
                              </TableCell>
                              <TableCell sx={{ py: 0.5 }}>
                                {item?.amountbft}
                              </TableCell>
                              <TableCell sx={{ py: 0.5 }}>
                                <Tooltip title="Delete Item">
                                  <IconButton
                                    color="primary"
                                    aria-label="Delete"
                                    onClick={() => {
                                      handleModalOpenDelete(index);
                                    }}
                                    sx={{ padding: 0, margin: 0 }}
                                  >
                                    <DeleteIcon sx={{ fontSize: "20px" }} />
                                  </IconButton>
                                </Tooltip>
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                    <Dialog
                      onClose={handleModalClose}
                      open={modalOpen}
                      maxWidth={"lg"}
                      sx={{
                        "& .MuiDialog-paper": {
                          marginTop: "-3vh",
                        },
                      }}
                    >
                      <IconButton
                        aria-label="close"
                        onClick={handleModalClose}
                        sx={{ position: "absolute", top: 0.1, right: 0.1 }}
                      >
                        <CloseIcon />
                      </IconButton>
                      <div className="d-flex justify-content-between align-items-center">
                        <DialogTitle sx={{ pb: 0 }}>
                          Packing Challan
                        </DialogTitle>
                        <DialogTitle sx={{ pb: 0, mr: 2, display: "flex" }}>
                          {SuppDsgnNmCD && !isEditItemForm ? (
                            <FormControlLabel
                              control={
                                <Switch
                                  checked={IsClrSize}
                                  onChange={handleSwitchClrSize}
                                  inputProps={{
                                    "aria-label": "controlled",
                                  }}
                                />
                              }
                              label="Add Colour/Size"
                            />
                          ) : (
                            <></>
                          )}
                          <Button
                            variant="contained"
                            sx={{ marginX: 1 }}
                            onClick={emptyFormData}
                          >
                            Clear
                          </Button>
                          {isEditItemForm ? (
                            <Button
                              id="itemButton"
                              variant="contained"
                              sx={{ marginX: 1 }}
                              onClick={() => {
                                return handleUpdateItemDetail(
                                  itemIndex,
                                  // TotalMeters,
                                  TotalQuantity,
                                  DsgRate,
                                );
                              }}
                            >
                              Save
                            </Button>
                          ) : (
                            <Button
                              id="itemButton"
                              variant="contained"
                              sx={{ marginX: 1 }}
                              onClick={() => {
                                return handleAddItemDetail(
                                  rowId,
                                  TotalQuantity,
                                  DsgRate,
                                );
                              }}
                            >
                              Add
                            </Button>
                          )}
                        </DialogTitle>
                      </div>
                      <DialogContent
                        sx={{
                          transition: "ease-in-out",
                          minWidth: "600px",
                          py: 1,
                        }}
                      >
                        <RadioGroup
                          row
                          aria-labelledby="demo-row-radio-buttons-group-label"
                          name="row-radio-buttons-group"
                          value={ItemRadio}
                          onChange={handleItemRadio}
                        >
                          {/* <FormControlLabel
                            disabled={isEditItemForm}
                            value="1"
                            control={<Radio />}
                            label="PO Wise"
                          /> */}
                          <FormControlLabel
                            disabled={isEditItemForm}
                            value="2"
                            control={<Radio />}
                            label="Design"
                          />
                        </RadioGroup>

                        {ItemRadio == "1" ? (
                          <Grid
                            container
                            spacing={1.3}
                            columns={12}
                            sx={{ mt: 1, width: "100%" }}
                          >
                            <Grid
                              item
                              xs={12}
                              sm={12}
                              md={12}
                              lg={12}
                              sx={{
                                display: "flex",
                                justifyContent: "start",
                              }}
                            >
                              {shouldReRender ? (
                                <Autocomplete
                                  disableClearable
                                  id="Mui-Autocomplete-POList"
                                  sx={{ width: POpendingID ? "50%" : "100%" }}
                                  renderInput={(params) => (
                                    <TextField
                                      autoFocus
                                      {...params}
                                      label="PO List"
                                    />
                                  )}
                                />
                              ) : null}
                              {!shouldReRender && (
                                <Autocomplete
                                  disableClearable
                                  id="Mui-Autocomplete-POList"
                                  value={POpendingID}
                                  onChange={(event, newValue) => {
                                    handlePOpending_ID(newValue);
                                  }}
                                  open={ListOpen}
                                  onOpen={handleListOpen}
                                  onClose={handleListClose}
                                  loading={ListLoading}
                                  options={POpendingListOption}
                                  componentsProps={{
                                    popper: {
                                      style: {
                                        width: "100vw",
                                        maxWidth: "730px",
                                      },
                                    },
                                  }}
                                  renderOption={(props, item) => (
                                    <table key={item.value}>
                                      {item.value ===
                                        POpendingListOption?.[0]?.value ? (
                                        <tbody
                                          {...props}
                                          style={{ padding: 0 }}
                                        >
                                          <tr>
                                            <td
                                              style={{ width: 200, padding: 0 }}
                                            >
                                              <div
                                                style={{
                                                  backgroundColor: "#F3F1F1",
                                                  padding: "6px 16px",
                                                  paddingRight: 0,
                                                  fontWeight: 600,
                                                }}
                                              >
                                                VNo.
                                              </div>
                                              <div
                                                style={{
                                                  padding: "6px 16px",
                                                  paddingRight: 0,
                                                }}
                                              >
                                                {
                                                  POpendingListOption?.[0]
                                                    ?.label
                                                }
                                              </div>
                                            </td>
                                            <td
                                              style={{ width: 130, padding: 0 }}
                                            >
                                              <div
                                                style={{
                                                  backgroundColor: "#F3F1F1",
                                                  padding: "6px 16px",
                                                  paddingRight: 0,
                                                  paddingLeft: "8px",
                                                  fontWeight: 600,
                                                }}
                                              >
                                                VDate
                                              </div>
                                              <div
                                                style={{
                                                  padding: "6px 16px",
                                                  paddingRight: 0,
                                                  paddingLeft: "8px",
                                                }}
                                              >
                                                {POpendingListOption?.[0]?.date}
                                              </div>
                                            </td>
                                          </tr>
                                        </tbody>
                                      ) : (
                                        <tbody {...props}>
                                          <tr>
                                            <td style={{ width: 200 }}>
                                              {item.label}
                                            </td>
                                            <td style={{ width: 130 }}>
                                              {item.date}
                                            </td>
                                            <td style={{ width: 400 }}>
                                              {item.party}
                                            </td>
                                          </tr>
                                        </tbody>
                                      )}
                                    </table>
                                  )}
                                  getOptionLabel={(option) =>
                                    option.label ? option.label : ""
                                  }
                                  isOptionEqualToValue={(option, value) =>
                                    option?.value === value?.value
                                  }
                                  sx={{ width: POpendingID ? "50%" : "100%" }}
                                  renderInput={(params) => (
                                    <TextField
                                      isGrid={false}
                                      autoFocus
                                      {...params}
                                      label="PO List"
                                    />
                                  )}
                                />
                              )}
                            </Grid>
                            <Dialog
                              onClose={handleModalCloseSecond}
                              open={modalOpenSecond}
                              maxWidth={"lg"}
                              sx={{
                                "& .MuiDialog-paper": {
                                  marginTop: "-3vh",
                                },
                              }}
                            >
                              <IconButton
                                aria-label="close"
                                onClick={handleModalCloseSecond}
                                sx={{
                                  position: "absolute",
                                  top: 0.1,
                                  right: 0.1,
                                }}
                              >
                                <CloseIcon />
                              </IconButton>
                              <div className="d-flex justify-content-between align-items-center">
                                <DialogTitle sx={{ pb: 1, fontSize: "20px" }}>
                                  PO Detail
                                </DialogTitle>
                                <DialogTitle sx={{ pb: 0, mr: 2 }}>
                                  <Button
                                    variant="contained"
                                    disabled={showItemDataArray.length <= 0}
                                    sx={{ marginX: 0.5 }}
                                    onClick={AddShowItemDataArray}
                                  >
                                    Add
                                  </Button>
                                </DialogTitle>
                              </div>
                              <DialogContent>
                                <TableContainer
                                  component={Paper}
                                  sx={{ py: 0.2 }}
                                >
                                  <ThemeProvider theme={innerformClr}>
                                    <Table
                                      stickyHeader
                                      sx={{ minWidth: 650 }}
                                      size="small"
                                      aria-label="a dense table"
                                    >
                                      <TableHead>
                                        <TableRow
                                          sx={{
                                            "& th": {
                                              backgroundColor: "#5198CD",
                                              color: "#fff",
                                            },
                                          }}
                                        >
                                          <TableCell
                                            sx={{
                                              display: "flex",
                                              flexDirection: "column",
                                            }}
                                          >
                                            Select
                                            {shouldReRender ? (
                                              <Checkbox
                                                checked={allChecked}
                                                inputProps={{
                                                  "aria-label": "controlled",
                                                }}
                                              />
                                            ) : null}
                                            {!shouldReRender && (
                                              <Checkbox
                                                checked={allChecked}
                                                onChange={(event) => {
                                                  return handleallCheckbox(
                                                    event.target.checked,
                                                  );
                                                }}
                                                inputProps={{
                                                  "aria-label": "controlled",
                                                }}
                                              />
                                            )}
                                          </TableCell>
                                          <TableCell>PO No.</TableCell>
                                          <TableCell>Date</TableCell>
                                          <TableCell>Design</TableCell>
                                          <TableCell>Product</TableCell>
                                          <TableCell>Rate</TableCell>
                                          <TableCell>Qty</TableCell>
                                          <TableCell>Unit</TableCell>
                                          <TableCell>Set</TableCell>
                                          <TableCell>View</TableCell>
                                        </TableRow>
                                      </TableHead>
                                      <TableBody>
                                        {showItemDataArray?.map(
                                          (item, index) => {
                                            return (
                                              <TableRow key={index}>
                                                <TableCell sx={{ py: 0.5 }}>
                                                  {shouldReRender ? (
                                                    <Checkbox
                                                      checked={
                                                        checkedList[index]
                                                      }
                                                      inputProps={{
                                                        "aria-label":
                                                          "controlled",
                                                      }}
                                                    />
                                                  ) : null}
                                                  {!shouldReRender && (
                                                    <Checkbox
                                                      checked={
                                                        checkedList[index]
                                                      }
                                                      onChange={(event) => {
                                                        return handleCheckboxChange(
                                                          event.target.checked,
                                                          index,
                                                        );
                                                      }}
                                                      inputProps={{
                                                        "aria-label":
                                                          "controlled",
                                                      }}
                                                    />
                                                  )}
                                                </TableCell>
                                                <TableCell sx={{ py: 0.5 }}>
                                                  {POpendingID?.label}
                                                </TableCell>
                                                <TableCell sx={{ py: 0.5 }}>
                                                  {POpendingID?.date}
                                                </TableCell>
                                                <TableCell sx={{ py: 0.5 }}>
                                                  {item?.supply_design}
                                                </TableCell>
                                                <TableCell sx={{ py: 0.5 }}>
                                                  {item?.product}
                                                </TableCell>
                                                <TableCell sx={{ py: 0.5 }}>
                                                  <TextField
                                                    name="showRate"
                                                    id="showRate"
                                                    value={item?.rate || ""}
                                                    onChange={(event) => {
                                                      const value = Number(
                                                        event.target.value
                                                          .replace(/[^0-9.]/g, "")
                                                          .replace(/(\..*)\./g, "$1")
                                                      );

                                                      handleEditShow("showRate", value, index);
                                                    }}
                                                    inputProps={{
                                                      inputMode: "decimal",
                                                      pattern:
                                                        "[0-9]*[.]?[0-9]*",
                                                    }}
                                                  />
                                                </TableCell>
                                                {item?.ClrSize?.length > 0 ||
                                                  Number(item?.PUC_Detail_SetId) >
                                                  0 ? (
                                                  <>
                                                    <TableCell sx={{ py: 0.5 }}>
                                                      {" "}
                                                      <TextField
                                                        disabled
                                                        name="showQty"
                                                        id="showQty"
                                                        value={item?.qty}
                                                        inputProps={{
                                                          inputMode: "decimal",
                                                          pattern:
                                                            "[0-9]*[.]?[0-9]*",
                                                        }}
                                                      />
                                                    </TableCell>
                                                    <TableCell sx={{ py: 0.5 }}>
                                                      {item?.unit}
                                                    </TableCell>
                                                  </>
                                                ) : Number(
                                                  item?.PUC_Detail_UnitID,
                                                ) ? (
                                                  <>
                                                    <TableCell sx={{ py: 0.5 }}>
                                                      {" "}
                                                      <TextField
                                                        id="showQty"
                                                        lablel="Quantity"
                                                        type="number"
                                                        value={item?.unit ?? ""}
                                                        handleOnChange={(
                                                          val,
                                                        ) => {
                                                          handleEditShow(
                                                            PODtlIdArray,
                                                            item?.id,
                                                            "showQty",
                                                            Number(val),
                                                            index,
                                                          );
                                                        }}
                                                        inputProps={{
                                                          inputMode: "decimal",
                                                          pattern:
                                                            "[0-9]*[.]?[0-9]*",
                                                          style: {
                                                            textAlign: "right",
                                                          },
                                                        }}
                                                      />
                                                    </TableCell>
                                                    <TableCell sx={{ py: 0.5 }}>
                                                      {item?.unit}
                                                    </TableCell>
                                                  </>
                                                ) : (
                                                  <>
                                                    <TableCell sx={{ py: 0.5 }}>
                                                      {" "}
                                                      <TextField
                                                        id="showQty"
                                                        lablel="Quantity"
                                                        type="number"
                                                        value={item?.qty ?? ""}
                                                        disabled={true}
                                                        inputProps={{
                                                          inputMode: "decimal",
                                                          pattern:
                                                            "[0-9]*[.]?[0-9]*",
                                                          style: {
                                                            textAlign: "right",
                                                          },
                                                        }}
                                                      />
                                                    </TableCell>
                                                    <TableCell sx={{ py: 0.5 }}>
                                                      {item?.unit}
                                                    </TableCell>
                                                  </>
                                                )}
                                                <TableCell sx={{ py: 0.5 }}>
                                                  {item?.PUC_Detail_SetId ? (
                                                    <Box
                                                      sx={{
                                                        display: "flex",
                                                        gap: 1,
                                                      }}
                                                    >
                                                      <Box
                                                        sx={{
                                                          bgcolor: ColorHex(
                                                            item?.ClrSize?.[0]
                                                              ?.colorId,
                                                          ),
                                                          width: 30,
                                                          height: 20,
                                                        }}
                                                      />
                                                      {colorName(
                                                        item?.ClrSize?.[0]
                                                          ?.colorId,
                                                      )}
                                                    </Box>
                                                  ) : (
                                                    <></>
                                                  )}
                                                </TableCell>
                                                <TableCell sx={{ py: 0.5 }}>
                                                  <IconButton
                                                    disabled={!item?.colors}
                                                    aria-label="View"
                                                    color="primary"
                                                    onClick={() => {
                                                      handleModalOpenThird(
                                                        item,
                                                        index,
                                                      );
                                                    }}
                                                  >
                                                    <RemoveRedEyeIcon />
                                                  </IconButton>
                                                </TableCell>
                                              </TableRow>
                                            );
                                          },
                                        )}
                                      </TableBody>
                                    </Table>
                                  </ThemeProvider>
                                </TableContainer>
                              </DialogContent>
                            </Dialog>
                            <Dialog
                              open={modalOpenThird}
                              onClose={() => setModalOpenThird(false)}
                              maxWidth="md"
                              fullWidth
                            >
                              <DialogTitle
                                sx={{
                                  m: 0,
                                  p: 2,
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                }}
                              >
                                Edit Color & Size Quantities
                                <IconButton
                                  onClick={() => setModalOpenThird(false)}
                                >
                                  <CloseIcon />
                                </IconButton>
                              </DialogTitle>

                              <DialogContent dividers>
                                <TableContainer
                                  component={Paper}
                                  sx={{ maxHeight: 450 }}
                                >
                                  <Table stickyHeader size="small">
                                    <TableHead>
                                      <TableRow>
                                        <TableCell
                                          sx={{
                                            fontWeight: "bold",
                                            bgcolor: "#f5f5f5",
                                          }}
                                        >
                                          Color/Size
                                        </TableCell>
                                        {viewRawClrSize?.[0]?.sizes?.map(
                                          (sz, index) => (
                                            <TableCell
                                              key={index}
                                              align="center"
                                              sx={{
                                                fontWeight: "bold",
                                                bgcolor: "#f5f5f5",
                                              }}
                                            >
                                              {sizeName(sz?.sizeId)}
                                            </TableCell>
                                          ),
                                        )}
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {viewRawClrSize?.map((item, index) => (
                                        <TableRow key={index} hover>
                                          {/* Color Name and Swatch */}
                                          <TableCell>
                                            <Box
                                              sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: 1,
                                              }}
                                            >
                                              <Box
                                                sx={{
                                                  bgcolor: item?.color_name,
                                                  width: 25,
                                                  height: 20,
                                                  border: "1px solid #ccc",
                                                  borderRadius: "4px",
                                                }}
                                              />
                                              {item?.color_name}
                                            </Box>
                                          </TableCell>


                                          {item?.sizes?.map((elem, ind) => (
                                            <TableCell key={ind} align="center">
                                              <TextField
                                                type="number"
                                                size="small"
                                                value={elem?.qty ?? elem?.bal_qty ?? ""}
                                                onChange={(e) => {
                                                  let value = Number(e.target.value);

                                                  const max = Number(elem?.bal_qty || 0);
                                                  if (value > max) {
                                                    showToast(`Max allowed is ${max}`, "error");
                                                    value = max;
                                                  }

                                                  handleEditShow(
                                                    "showClrSize",
                                                    value,
                                                    index,
                                                    elem?.sizeId
                                                  );
                                                }}
                                                inputProps={{
                                                  min: 0,
                                                  style: { textAlign: "center", width: "60px" },
                                                }}
                                              />
                                            </TableCell>
                                          ))}
                                        </TableRow>
                                      ))}
                                    </TableBody>
                                  </Table>
                                </TableContainer>
                              </DialogContent>

                              <DialogActions sx={{ p: 2 }}>
                                <Button
                                  onClick={() => setModalOpenThird(false)}
                                  color="inherit"
                                  variant="outlined"
                                >
                                  Cancel
                                </Button>
                                <Button
                                  onClick={handleFinalSave}
                                  color="primary"
                                  variant="contained"
                                >
                                  Update Changes
                                </Button>
                              </DialogActions>
                            </Dialog>
                          </Grid>
                        ) : (
                          <></>
                        )}

                        {ItemRadio == "2" ? (
                          <Grid
                            container
                            spacing={1.3}
                            columns={12}
                            sx={{ mt: 1, width: "100%" }}
                          >
                            <Grid
                              item
                              xs={12}
                              sm={12}
                              md={12}
                              lg={12}
                              sx={{
                                display: "flex",
                                justifyContent: "start",
                              }}
                            >
                              {shouldReRender ? (
                                <Autocomplete
                                  id="Mui-Autocomplete-SupplyDesign"
                                  sx={{
                                    width: SuppDsgnNmCD ? "50%" : "100%",
                                  }}
                                  renderInput={(params) => (
                                    <TextField
                                      autoFocus
                                      {...params}
                                      label="Design"
                                    />
                                  )}
                                />
                              ) : null}
                              {!shouldReRender && (
                                <Autocomplete
                                  disableClearable
                                  id="Mui-Autocomplete-SupplyDesign"
                                  open={ListOpen}
                                  onOpen={handleListOpen}
                                  onClose={handleListClose}
                                  loading={ListLoading}
                                  value={SuppDsgnNmCD}
                                  onChange={(event, newValue) => {
                                    handleSupDsnCode_ID(newValue);
                                  }}
                                  options={SupplydsgnList?.sort(sortByLabel)}
                                  componentsProps={{
                                    popper: {
                                      style: {
                                        width: "100vw",
                                        maxWidth: "700px",
                                      },
                                    },
                                  }}
                                  renderOption={(props, item) => (
                                    <table key={item.value}>
                                      {item.value ===
                                        SupplydsgnList[0]?.value ? (
                                        <tbody
                                          {...props}
                                          style={{ padding: 0 }}
                                        >
                                          <tr>
                                            <td
                                              style={{
                                                width: 400,
                                                padding: 0,
                                              }}
                                            >
                                              <div
                                                style={{
                                                  backgroundColor: "#F3F1F1",
                                                  padding: "6px 16px",
                                                  paddingRight: 0,
                                                  fontWeight: 600,
                                                }}
                                              >
                                                Supply Design
                                              </div>
                                              <div
                                                style={{
                                                  padding: "6px 16px",
                                                  paddingRight: 0,
                                                }}
                                              >
                                                {SupplydsgnList[0]?.label}
                                              </div>
                                            </td>
                                            <td
                                              style={{
                                                width: 300,
                                                padding: 0,
                                              }}
                                            >
                                              <div
                                                style={{
                                                  backgroundColor: "#F3F1F1",
                                                  padding: "6px 16px",
                                                  paddingLeft: 0,
                                                  fontWeight: 600,
                                                }}
                                              >
                                                Product
                                              </div>
                                              <div
                                                style={{
                                                  padding: "6px 16px",
                                                  paddingLeft: 0,
                                                }}
                                              >
                                                {SupplydsgnList[0]?.product}
                                              </div>
                                            </td>
                                          </tr>
                                        </tbody>
                                      ) : (
                                        <tbody {...props}>
                                          <tr>
                                            <td style={{ width: 400 }}>
                                              {item.label}
                                            </td>
                                            <td style={{ width: 300 }}>
                                              {item.product}
                                            </td>
                                          </tr>
                                        </tbody>
                                      )}
                                    </table>
                                  )}
                                  filterOptions={(options, params) => {
                                    const filtered = filter(options, params);
                                    if (
                                      params.inputValue !== "" &&
                                      filtered?.length < 1
                                    ) {
                                      filtered.push({
                                        label: `Add "${params.inputValue}"`,
                                        value: 0,
                                      });
                                    }
                                    return filtered;
                                  }}
                                  getOptionLabel={(option) =>
                                    option.label ? option.label : ""
                                  }
                                  isOptionEqualToValue={(option, value) =>
                                    option?.value === value?.value
                                  }
                                  sx={{
                                    width: SuppDsgnNmCD ? "50%" : "100%",
                                  }}
                                  renderInput={(params) => (
                                    <TextField
                                      autoFocus
                                      {...params}
                                      label="Supply Design"
                                      InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                          <>
                                            {ListLoading ? (
                                              <CircularProgress
                                                color="inherit"
                                                size={20}
                                                sx={{ mt: -1 }}
                                              />
                                            ) : null}
                                            {params.InputProps.endAdornment}
                                          </>
                                        ),
                                      }}
                                    />
                                  )}
                                />
                              )}
                            </Grid>

                            {SuppDsgnNmCD || PodIdNme ? (
                              <>
                                <Grid
                                  container
                                  spacing={1.3}
                                  columns={12}
                                  sx={{ mt: 1, width: "100%" }}
                                >
                                  <Grid
                                    item
                                    xs={12}
                                    sm={6}
                                    md={3}
                                    lg={3}
                                    sx={{
                                      display: "flex",
                                      justifyContent: "center",
                                    }}
                                  >
                                    {shouldReRender ? (
                                      <TextField
                                        id="Product"
                                        label="Product"
                                        sx={{ width: "100%" }}
                                      />
                                    ) : null}
                                    {!shouldReRender && (
                                      <TextField
                                        disabled
                                        id="Product"
                                        label="Product"
                                        value={PodIdNme?.label}
                                        InputLabelProps={{
                                          shrink:
                                            PodIdNme?.label != undefined
                                              ? true
                                              : false,
                                        }}
                                        sx={{ width: "100%" }}
                                      />
                                    )}
                                  </Grid>
                                  <Grid
                                    item
                                    xs={12}
                                    sm={6}
                                    md={3}
                                    lg={3}
                                    sx={{
                                      display: "flex",
                                      justifyContent: "center",
                                    }}
                                  >
                                    {shouldReRender ? (
                                      <TextField
                                        id="Qty"
                                        label="Qty"
                                        sx={{ width: "100%" }}
                                      />
                                    ) : null}
                                    {!shouldReRender &&
                                      (IsClrSize === true ? (
                                        <TextField
                                          disabled
                                          id="Qty"
                                          label="Qty"
                                          value={TotalQuantity}
                                          InputLabelProps={{
                                            shrink:
                                              TotalQuantity != undefined
                                                ? true
                                                : false,
                                          }}
                                          InputProps={{
                                            inputProps: { min: 0 },
                                          }}
                                          type="number"
                                          sx={{ width: "100%" }}
                                        />
                                      ) : (
                                        <TextField
                                          id="Qty"
                                          label="Qty"
                                          value={TotalQuantity}
                                          onChange={handleQuantity}
                                          onBlur={() => setQtyInputfocus(false)}
                                          inputRef={(input) =>
                                            QtyInputfocus &&
                                            !Loader &&
                                            input?.focus()
                                          }
                                          InputLabelProps={{
                                            shrink:
                                              TotalQuantity != undefined
                                                ? true
                                                : false,
                                          }}
                                          InputProps={{
                                            inputProps: {
                                              min: 0,
                                            },
                                          }}
                                          type="number"
                                          sx={{ width: "100%" }}
                                        />
                                      ))}
                                  </Grid>
                                  <Grid
                                    item
                                    xs={12}
                                    sm={6}
                                    md={3}
                                    lg={3}
                                    sx={{
                                      display: "flex",
                                      justifyContent: "center",
                                    }}
                                  >
                                    {shouldReRender ? (
                                      <TextField
                                        id="Rate"
                                        label="Rate"
                                        sx={{ width: "100%" }}
                                      />
                                    ) : null}
                                    {!shouldReRender && (
                                      <TextField
                                        id="Rate"
                                        label="Rate"
                                        value={DsgRate}
                                        onChange={handleRateChange}
                                        InputProps={{ inputProps: { min: 0 } }}
                                        type="number"
                                        InputLabelProps={{
                                          shrink:
                                            DsgRate != undefined ? true : false,
                                        }}
                                        sx={{ width: "100%" }}
                                      />
                                    )}
                                    {shouldReRender ? (
                                      <TextField
                                        id="Discount %"
                                        label="Discount %"
                                        sx={{ width: "100%" }}
                                      />
                                    ) : null}
                                    {!shouldReRender &&
                                      (isDisAmt == true ? (
                                        <TextField
                                          disabled
                                          id="Discount %"
                                          label="Discount %"
                                          value={DiscountPer}
                                          InputLabelProps={{
                                            shrink:
                                              DiscountPer != undefined
                                                ? true
                                                : false,
                                          }}
                                          sx={{ width: "100%" }}
                                        />
                                      ) : (
                                        <TextField
                                          id="Discount %"
                                          label="Discount %"
                                          value={DiscountPer}
                                          onChange={handleDiscountPer}
                                          InputLabelProps={{
                                            shrink:
                                              DiscountPer != undefined
                                                ? true
                                                : false,
                                          }}
                                          inputProps={{
                                            maxlength: 4,
                                          }}
                                          sx={{ width: "100%" }}
                                        />
                                      ))}
                                  </Grid>
                                  <Grid
                                    item
                                    xs={12}
                                    sm={6}
                                    md={3}
                                    lg={3}
                                    sx={{
                                      display: "flex",
                                      justifyContent: "center",
                                    }}
                                  >
                                    <Checkbox
                                      checked={isDisAmt}
                                      onChange={() => {
                                        return setIsDisAmt(!isDisAmt);
                                      }}
                                      inputProps={{
                                        "aria-label": "controlled",
                                      }}
                                    />
                                    {shouldReRender ? (
                                      <TextField
                                        id="Discount Amt."
                                        label="Discount Amt."
                                        sx={{ width: "100%" }}
                                      />
                                    ) : null}
                                    {!shouldReRender &&
                                      (isDisAmt == true ? (
                                        <TextField
                                          id="Discount Amt."
                                          label="Discount Amt."
                                          value={DiscountAmt}
                                          onChange={handleDiscountAmt}
                                          InputLabelProps={{
                                            shrink:
                                              DiscountAmt != undefined
                                                ? true
                                                : false,
                                          }}
                                          sx={{ width: "100%" }}
                                        />
                                      ) : (
                                        <TextField
                                          disabled
                                          id="Discount Amt."
                                          label="Discount Amt."
                                          value={DiscountAmt}
                                          InputLabelProps={{
                                            shrink:
                                              DiscountAmt != undefined
                                                ? true
                                                : false,
                                          }}
                                          sx={{ width: "100%" }}
                                        />
                                      ))}
                                    {shouldReRender ? (
                                      <TextField
                                        disabled
                                        id="After Dis. Rate"
                                        label="After Dis. Rate"
                                        sx={{ width: "100%" }}
                                      />
                                    ) : null}
                                    {!shouldReRender && (
                                      <TextField
                                        disabled
                                        id="After Dis. Rate"
                                        label="After Dis. Rate"
                                        value={DiscountedRate(
                                          DsgRate,
                                          DiscountPer,
                                        )}
                                        InputLabelProps={{
                                          shrink:
                                            DiscountedRate(
                                              DsgRate,
                                              DiscountPer,
                                            ) != undefined
                                              ? true
                                              : false,
                                        }}
                                        sx={{ width: "100%" }}
                                      />
                                    )}
                                  </Grid>

                                  <Grid
                                    item
                                    xs={12}
                                    sm={6}
                                    md={3}
                                    lg={3}
                                    sx={{
                                      display: "flex",
                                      justifyContent: "center",
                                    }}
                                  >
                                    {shouldReRender ? (
                                      <TextField
                                        id="Amount BFT"
                                        label="Amount BFT"
                                        sx={{ width: "100%" }}
                                      />
                                    ) : null}
                                    {!shouldReRender && (
                                      <TextField
                                        disabled
                                        id="Amount BFT"
                                        label="Amount BFT"
                                        value={AmountBFT}
                                        InputLabelProps={{
                                          shrink:
                                            AmountBFT != undefined
                                              ? true
                                              : false,
                                        }}
                                        InputProps={{ inputProps: { min: 0 } }}
                                        type="number"
                                        sx={{ width: "100%" }}
                                      />
                                    )}
                                  </Grid>
                                  <Grid
                                    item
                                    xs={12}
                                    sm={6}
                                    md={3}
                                    lg={3}
                                    sx={{
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                    }}
                                  >
                                    {shouldReRender ? (
                                      <>
                                        <TextField
                                          id="CGST"
                                          label="CGST%"
                                          InputProps={{
                                            inputProps: { min: 0 },
                                          }}
                                          type="number"
                                          sx={{ width: "30%" }}
                                        />
                                        <TextField
                                          id="CGSTAmt"
                                          label="CGSTAmt"
                                          InputProps={{
                                            inputProps: { min: 0 },
                                          }}
                                          type="number"
                                          sx={{ width: "70%" }}
                                        />
                                      </>
                                    ) : null}
                                    {!shouldReRender && (
                                      <>
                                        <TextField
                                          disabled
                                          id="CGST"
                                          label="CGST%"
                                          value={GstRates?.cgst}
                                          InputLabelProps={{
                                            shrink:
                                              GstRates?.cgst != undefined
                                                ? true
                                                : false,
                                          }}
                                          InputProps={{
                                            inputProps: { min: 0 },
                                          }}
                                          type="number"
                                          sx={{ width: "30%" }}
                                        />
                                        <TextField
                                          disabled
                                          id="CGSTAmt"
                                          label="CGSTAmt"
                                          value={cgstValue}
                                          InputLabelProps={{
                                            shrink:
                                              cgstValue != undefined
                                                ? true
                                                : false,
                                          }}
                                          InputProps={{
                                            inputProps: { min: 0 },
                                          }}
                                          type="number"
                                          sx={{ width: "70%" }}
                                        />
                                      </>
                                    )}
                                  </Grid>
                                  <Grid
                                    item
                                    xs={12}
                                    sm={6}
                                    md={3}
                                    lg={3}
                                    sx={{
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                    }}
                                  >
                                    {shouldReRender ? (
                                      <>
                                        <TextField
                                          id="SGST"
                                          label="SGST%"
                                          InputProps={{
                                            inputProps: { min: 0 },
                                          }}
                                          type="number"
                                          sx={{ width: "30%" }}
                                        />
                                        <TextField
                                          id="SGSTAmt"
                                          label="SGSTAmt"
                                          InputProps={{
                                            inputProps: { min: 0 },
                                          }}
                                          type="number"
                                          sx={{ width: "70%" }}
                                        />
                                      </>
                                    ) : null}
                                    {!shouldReRender && (
                                      <>
                                        <TextField
                                          disabled
                                          id="SGST"
                                          label="SGST%"
                                          value={GstRates?.sgst}
                                          InputLabelProps={{
                                            shrink:
                                              GstRates?.sgst != undefined
                                                ? true
                                                : false,
                                          }}
                                          InputProps={{
                                            inputProps: { min: 0 },
                                          }}
                                          type="number"
                                          sx={{ width: "30%" }}
                                        />
                                        <TextField
                                          disabled
                                          id="SGSTAmt"
                                          label="SGSTAmt"
                                          value={sgstValue}
                                          InputLabelProps={{
                                            shrink:
                                              sgstValue != undefined
                                                ? true
                                                : false,
                                          }}
                                          InputProps={{
                                            inputProps: { min: 0 },
                                          }}
                                          type="number"
                                          sx={{ width: "70%" }}
                                        />
                                      </>
                                    )}
                                  </Grid>
                                  <Grid
                                    item
                                    xs={12}
                                    sm={6}
                                    md={3}
                                    lg={3}
                                    sx={{
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                    }}
                                  >
                                    {shouldReRender ? (
                                      <>
                                        <TextField
                                          id="IGST"
                                          label="IGST%"
                                          InputProps={{
                                            inputProps: { min: 0 },
                                          }}
                                          type="number"
                                          sx={{ width: "30%" }}
                                        />
                                        <TextField
                                          id="IGSTAmt"
                                          label="IGSTAmt"
                                          InputProps={{
                                            inputProps: { min: 0 },
                                          }}
                                          type="number"
                                          sx={{ width: "70%" }}
                                        />
                                      </>
                                    ) : null}
                                    {!shouldReRender && (
                                      <>
                                        <TextField
                                          disabled
                                          id="IGST"
                                          label="IGST%"
                                          value={GstRates?.igst}
                                          InputLabelProps={{
                                            shrink:
                                              GstRates?.igst != undefined
                                                ? true
                                                : false,
                                          }}
                                          InputProps={{
                                            inputProps: { min: 0 },
                                          }}
                                          type="number"
                                          sx={{ width: "30%" }}
                                        />
                                        <TextField
                                          disabled
                                          id="IGSTAmt"
                                          label="IGSTAmt"
                                          value={igstValue}
                                          InputLabelProps={{
                                            shrink:
                                              igstValue != undefined
                                                ? true
                                                : false,
                                          }}
                                          InputProps={{
                                            inputProps: { min: 0 },
                                          }}
                                          type="number"
                                          sx={{ width: "70%" }}
                                        />
                                      </>
                                    )}
                                  </Grid>

                                  <Grid
                                    item
                                    xs={12}
                                    sm={6}
                                    md={3}
                                    lg={3}
                                    sx={{
                                      display: "flex",
                                      justifyContent: "center",
                                    }}
                                  >
                                    {shouldReRender ? (
                                      <TextField
                                        id="TotalAmount"
                                        label="Total Amount"
                                        sx={{ width: "100%" }}
                                      />
                                    ) : null}
                                    {!shouldReRender && (
                                      <TextField
                                        disabled
                                        id="TotalAmount"
                                        label="Total Amount"
                                        value={itemTotalAmt}
                                        InputLabelProps={{
                                          shrink:
                                            itemTotalAmt != undefined
                                              ? true
                                              : false,
                                        }}
                                        InputProps={{ inputProps: { min: 0 } }}
                                        type="number"
                                        sx={{ width: "100%" }}
                                      />
                                    )}
                                  </Grid>
                                </Grid>
                                {IsClrSize ? (
                                  <TableContainer
                                    component={Paper}
                                    sx={{
                                      mt: 2,
                                      minWidth: "60vw",
                                    }}
                                  >
                                    <ThemeProvider theme={innerformClr}>
                                      <Table
                                        stickyHeader
                                        size="small"
                                        aria-label="simple table"
                                      >
                                        <TableHead>
                                          <TableRow>
                                            <TableCell sx={{ py: 2 }}>
                                              Color/Size
                                            </TableCell>
                                            {UniqueSizes?.map((item, index) => (
                                              <TableCell
                                                align="center"
                                                key={index}
                                              >
                                                {item}
                                              </TableCell>
                                            ))}
                                          </TableRow>
                                        </TableHead>
                                        <TableBody>
                                          {(!shouldReRenderRaw
                                            ? RawClrSize
                                            : []
                                          )?.map((item, index) => {
                                            return (
                                              <TableRow key={index}>
                                                <TableCell>
                                                  {item?.color_name}
                                                </TableCell>
                                                {UniqueSizes?.map(
                                                  (elem, index) =>
                                                    item?.sizes?.find(
                                                      (el) =>
                                                        el?.size_name == elem,
                                                    ) ? (
                                                      <TableCell
                                                        key={index}
                                                        align="center"
                                                      >
                                                        <TextField
                                                          name={
                                                            item?.color_name +
                                                            "." +
                                                            item?.sizes?.find(
                                                              (el) =>
                                                                el?.size_name ==
                                                                elem,
                                                            )?.size_name
                                                          }
                                                          label="Qty"
                                                          value={
                                                            item?.sizes?.find(
                                                              (el) =>
                                                                el?.size_name ==
                                                                elem,
                                                            )?.qty
                                                          }
                                                          onChange={
                                                            ClrSizehandler
                                                          }
                                                          InputProps={{
                                                            inputProps: {
                                                              min: 0,
                                                            },
                                                          }}
                                                          type="number"
                                                          InputLabelProps={{
                                                            shrink:
                                                              item?.sizes?.find(
                                                                (el) =>
                                                                  el?.size_name ==
                                                                  elem,
                                                              )?.qty !=
                                                                undefined
                                                                ? true
                                                                : false,
                                                          }}
                                                          sx={{ mt: 0.4 }}
                                                        />
                                                      </TableCell>
                                                    ) : (
                                                      <TableCell align="center">
                                                        -
                                                      </TableCell>
                                                    ),
                                                )}
                                              </TableRow>
                                            );
                                          })}
                                        </TableBody>
                                      </Table>
                                      {/* <Box sx={{ px: 1 }}>
                                        <Tooltip title="Add Color/Size">
                                          <IconButton
                                            color="primary"
                                            aria-label="add"
                                          >
                                            <AddCircleOutlinedIcon
                                              onClick={handleModalOpenAddClrSize}
                                            />
                                          </IconButton>
                                        </Tooltip>
                                      </Box> */}
                                    </ThemeProvider>
                                  </TableContainer>
                                ) : (
                                  // <Box style={{ display: "flex", justifyContent: "center", padding: "15px" }}>
                                  //   No Color/Size Available
                                  // </Box>
                                  <></>
                                )}
                              </>
                            ) : (
                              <></>
                            )}
                          </Grid>
                        ) : (
                          <></>
                        )}
                      </DialogContent>
                    </Dialog>
                  </TabPanel>
                </TabContext>
              </Box>
            </ThemeProvider>
          </div>
          <ThemeProvider theme={form}>
            <Paper
              sx={{
                py: 1.5,
                width: "100%",
                height: "58px",
                overflowY: "scroll",
                "::-webkit-scrollbar": {
                  display: "none",
                },
              }}
            >
              <Grid
                container
                spacing={1.3}
                columns={12}
                sx={{ width: "100%", padding: "0 10px 0 10px" }}
              >
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={2}
                  lg={2}
                  sx={{ display: "flex", justifyContent: "center" }}
                >
                  <TextField
                    disabled
                    id="Qty"
                    label="Qty"
                    value={mainTotalQty}
                    InputLabelProps={{
                      shrink: mainTotalQty != undefined ? true : false,
                    }}
                    InputProps={{ inputProps: { min: 0 } }}
                    type="number"
                    sx={{ width: "100%" }}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={2}
                  lg={2}
                  sx={{ display: "flex", justifyContent: "center" }}
                >
                  <TextField
                    disabled
                    id="Taxable"
                    label="Taxable"
                    value={mainTotalTaxableAmt}
                    InputLabelProps={{
                      shrink: mainTotalTaxableAmt != undefined ? true : false,
                    }}
                    InputProps={{ inputProps: { min: 0 } }}
                    type="number"
                    sx={{ width: "100%" }}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={2}
                  lg={2}
                  sx={{ display: "flex", justifyContent: "center" }}
                >
                  <TextField
                    disabled
                    id="CGST"
                    label="CGST"
                    value={mainTotalItemCgst}
                    InputLabelProps={{
                      shrink: mainTotalItemCgst != undefined ? true : false,
                    }}
                    InputProps={{ inputProps: { min: 0 } }}
                    type="number"
                    sx={{ width: "100%" }}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={2}
                  lg={2}
                  sx={{ display: "flex", justifyContent: "center" }}
                >
                  <TextField
                    disabled
                    id="SGST"
                    label="SGST"
                    value={mainTotalItemSgst}
                    InputLabelProps={{
                      shrink: mainTotalItemSgst != undefined ? true : false,
                    }}
                    InputProps={{ inputProps: { min: 0 } }}
                    type="number"
                    sx={{ width: "100%" }}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={2}
                  lg={2}
                  sx={{ display: "flex", justifyContent: "center" }}
                >
                  <TextField
                    disabled
                    id="IGST"
                    label="IGST"
                    value={mainTotalItemIgst}
                    InputLabelProps={{
                      shrink: mainTotalItemIgst != undefined ? true : false,
                    }}
                    InputProps={{ inputProps: { min: 0 } }}
                    type="number"
                    sx={{ width: "100%" }}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={2}
                  lg={2}
                  sx={{ display: "flex", justifyContent: "center" }}
                >
                  <TextField
                    disabled
                    id="Total Amount"
                    label="Total Amount"
                    value={mainTotalAmount}
                    InputLabelProps={{
                      shrink: mainTotalAmount != undefined ? true : false,
                    }}
                    InputProps={{ inputProps: { min: 0 } }}
                    type="number"
                    sx={{ width: "100%" }}
                  />
                </Grid>
              </Grid>
            </Paper>
          </ThemeProvider>
          {/* <TotalDetail
            mainTotalQty={mainTotalQty}
            mainTotalTaxableAmt={mainTotalTaxableAmt}
            mainTotalCgst={mainTotalItemCgst}
            mainTotalSgst={mainTotalItemSgst}
            mainTotalIgst={mainTotalItemIgst}
            mainTotalAmount={mainTotalAmount}
          /> */}
        </ThemeProvider>
      </div>

      <Toaster position="top-center" reverseOrder={false} />
    </>
  );
}
